import { ALL_LANGUAGES } from 'constants/LanguageConstants';
import { LargeDistanceUnit, SmallDistanceUnit } from 'constants/UnitConstants';
import { createLabel } from 'utils/utils';

export const translations = {
  'advice.tire.brand': 'Brand: {brand}',
  'advice.tire.depth': 'Current depth: {depth}',
  'advice.tire.diameter': 'Diameter: {diameter}',
  'advice.tire.dot': 'DOT: {dot}',
  'advice.tire.loadIndex': 'Load index: {loadIndex}',
  'advice.tire.original': 'Original tire:',
  'advice.tire.pressure': 'Pressure: {pressure}',
  'advice.tire.ratio': 'Ratio: {ratio}',
  'advice.tire.season': 'Season: {season}',
  'advice.tire.speedIndex': 'Speed index: {speedIndex}',
  'advice.tire.width': 'Width: {width}',
  'audit.no.response': 'Without response',
  'audit.statistics.export.unanswered': 'unanswered',
  'audito.audit': 'Audit',
  'audito.audit_status.closed': 'Archived',
  'audito.audit_status.deleted': 'Deleted',
  'audito.audit_status.draft': 'Draft',
  'audito.audit_status.in_progress': 'In progress',
  'audito.audit_status.open': 'Completed',
  'audito.model.builder.sections.section.question.notifyWhenComplete':
    'Use the answer to send notification email when audit is complete',
  'audito.model.builder.sections.section.question.type.email': 'Email question',
  'audito.model.severity.high': 'Urgent',
  'audito.model.severity.low': 'Recommended',
  'audito.model.severity.none': 'Good',
  'audito.question.brand-question.params.brand': 'Brand',
  'audito.question.brand-question.params.employees': 'Employees',
  'audito.question.kpi-question.params.comment': 'Comment:',
  'audito.question.kpi-question.params.current': 'Current:',
  'audito.question.kpi-question.params.date': 'Date:',
  'audito.question.kpi-question.params.responsible': 'Responsible:',
  'audito.question.kpi-question.params.status': 'Status:',
  'audito.question.kpi-question.params.target': 'Target:',
  'audito.question.thickness-question.params.initial-thickness': 'Initial thickness ({unit}):',
  'audito.question.thickness-question.params.measured-thickness': 'Measured thickness ({unit}):',
  'audito.question.thickness-question.params.minimal-thickness': 'Minimal thickness ({unit}):',
  'audito.question.thickness-question.severity-label': 'Severity:',
  'audito.raw-data.elapsed-time-in-sec': 'Elapsed time (s)',
  'audito.section.empty': 'Nothing to display. Your answers don’t meet the conditions in this section.',
  'brand.abarth': 'Abarth',
  'brand.alfa_romeo': 'Alfa Romeo',
  'brand.alpina': 'Alpina',
  'brand.alpine': 'Alpine',
  'brand.astonmartin': 'Aston Martin',
  'brand.audi': 'Audi',
  'brand.audi-occasion-plus': 'Audi Occasion :plus',
  'brand.autosphere': 'Autosphere',
  'brand.bentley': 'Bentley',
  'brand.bicycle': 'Bicycle',
  'brand.bilia': 'Bilia',
  'brand.bmw': 'BMW',
  'brand.bmw.motorrad': 'BMW Motorrad',
  'brand.bmw_m': 'BMW M',
  'brand.bmw_service': 'BMW Service',
  'brand.bmwi': 'BMWi',
  'brand.bus': 'Bus',
  'brand.cadillac': 'Cadillac',
  'brand.camping': 'Leisure vehicles',
  'brand.chrysler': 'Chrysler',
  'brand.citroen': 'Citroën',
  'brand.cupra': 'Cupra',
  'brand.dacia': 'Dacia',
  'brand.das-weltauto': 'Das WeltAuto',
  'brand.dg8cars': 'DG8Cars',
  'brand.dg8eco': 'DG8Eco',
  'brand.dodge': 'Dodge',
  'brand.ds': 'DS',
  'brand.ducati': 'Ducati',
  'brand.ferrari': 'Ferrari',
  'brand.fiat': 'Fiat',
  'brand.fiat_professional': 'Fiat Professional',
  'brand.ford': 'Ford',
  'brand.holmgrens_bil': 'Holmgrens Bil',
  'brand.honda': 'Honda',
  'brand.honda_moto': 'Honda Moto',
  'brand.hymer': 'Hymer',
  'brand.hyundai': 'Hyundai',
  'brand.id_not_found': 'The brand with the identifier: {0} could not be found.',
  'brand.isuzu': 'Isuzu',
  'brand.iveco': 'Iveco',
  'brand.jaguar': 'Jaguar',
  'brand.jeep': 'Jeep',
  'brand.kia': 'Kia',
  'brand.lamborghini': 'Lamborghini',
  'brand.lancia': 'Lancia',
  'brand.land_rover': 'Land Rover',
  'brand.levc': 'LEVC',
  'brand.lexus': 'Lexus',
  'brand.ligier': 'Ligier',
  'brand.man': 'MAN',
  'brand.mannes': 'Mannes',
  'brand.maserati': 'Maserati',
  'brand.mazda': 'Mazda',
  'brand.mclaren': 'McLaren',
  'brand.mercedes_amg': 'Mercedes AMG',
  'brand.mercedes_benz': 'Mercedes-Benz',
  'brand.mercedes_professional': 'Mercedes Professional',
  'brand.mercedes_truck': 'Mercedes Truck',
  'brand.mg': 'MG',
  'brand.mini': 'MINI',
  'brand.mitsubishi': 'Mitsubishi',
  'brand.mustang': 'Mustang',
  'brand.nissan': 'Nissan',
  'brand.opel': 'Opel',
  'brand.other': 'Other Brand',
  'brand.peugeot': 'Peugeot',
  'brand.peugeot-professional': 'Peugeot Professional',
  'brand.porsche': 'Porsche',
  'brand.renault': 'Renault',
  'brand.renault-trucks': 'Renault Trucks',
  'brand.rollsroyce': 'Rolls-Royce',
  'brand.scania': 'Scania',
  'brand.seat': 'Seat',
  'brand.skoda': 'Skoda',
  'brand.smart': 'Smart',
  'brand.suzuki': 'Suzuki',
  'brand.toyota': 'Toyota',
  'brand.truck': 'Truck',
  'brand.volkswagen': 'Volkswagen',
  'brand.volkswagen_professional': 'Volkswagen Professional',
  'brand.volvo': 'Volvo',
  'brand.vsp_vo': 'VSP VO',
  'car_config.common.no': 'Non',
  'car_config.common.yes': 'Oui',
  'car_config.conditions.0.body':
    "La date ou le délai de livraison indiqué sur le bon de commande est d'application stricte (hors le cas de force majeure). Le délai de livraison prend cours le jour qui suit celui de la signature du bon de commande par l'Acheteur.\n1.1. Lorsque le Vendeur ne peut pas respecter cette date ou ce délai de livraison, il en informe l'Acheteur immédiatement par lettre recommandée ou par tout autre moyen de preuve légale.\nLe Vendeur peut communiquer dans cette lettre une prolongation de la date ou du délai de livraison qui ne pourra cependant excéder 25% du délai convenu initialement.\nHors le cas de force majeure, si ce nouveau délai est dépassé, l'Acheteur peut résilier le contrat dans un délai d'un mois, après la fin de la prolongation, par lettre recommandée sans mise en demeure préalable et sans préjudice d'une indemnité correspondant au dommage réellement subi, toutefois limité à 15% du prix de vente total du véhicule (TVA exclue).\nEn cas de résiliation, l'acompte est remboursé dans les huit jours calendrier qui suivent la réception de la notification de cette résiliation.Les deux alinéas précédents sont également d'application si le Vendeur en retard de livraison n'a pas communiqué une prolongation des délais, conformément aux alinéas 1 et 2.\n1.2 Lorsque l'Acheteur ne prend pas livraison du véhicule à la date ou dans le délai de livraison convenu, le Vendeur a le droit, après écoulement d'un délai de dix jours calendrier à partir de l'envoi d'une mise en demeure par lettre recommandée, sauf si l'Acheteur prouve que le défaut de prise de possession du véhicule est la conséquence d'un cas de force majeure :\n- de réclamer les frais de garage,\n- de résilier la vente et d'exiger une indemnité qui correspond au dommage réellement subi. Toutefois limité à 15% du prix de vente total du véhicule (TVA exclue).",
  'car_config.conditions.0.title': '1. Date ou délai de livraison',
  'car_config.conditions.1.body':
    "2.1. Les prix hors taxes mentionnés sur le bon de commande ne peuvent être augmentés, sans préjudice de l'application des dispositions suivantes.\n2.2. Lorsque la date convenue pour la livraison est postérieure à un délai de 4 mois ou lorsque le délai de livraison est de plus de 4 mois, le Vendeur peut répercuter sur le prix convenu toute modification du prix maximum (prix catalogue) conseillé par l'importateur ou le producteur.\nSi le prix convenu est ainsi augmenté, le Vendeur a l'obligation d'en informer l'Acheteur immédiatement, de manière claire et non équivoque, par une lettre recommandée. Dans celle-ci, il doit aussi être fait mention de la possibilité pour l'Acheteur de résilier le contrat.\nS'il y a augmentation du prix, l'Acheteur peut résilier le contrat par lettre recommandée, dans les dix jours calendrier après la réception de la communication de la hausse de prix. L'acompte éventuel sera remboursé dans les huit jours calendrier suivant la réception de l'envoi recommandé de l'Acheteur.\n2.3. Lorsque, par application du point 1.1., 2ème alinéa, la date convenue pour la livraison est dépassée ou le délai de livraison prolongé, le prix convenu hors taxes ne peut subir aucune majoration.\n2.4. Le prix des équipements légalement obligatoires fixés à demeure est réputé inclus dans le prix annoncé.",
  'car_config.conditions.1.title': '2. Prix',
  'car_config.conditions.2.body':
    "3.1. La livraison du véhicule se fait au siège du Vendeur, sauf convention écrite contraire.\n3.2. L'Acheteur supporte tous les risques relatifs au véhicule à partir de sa livraison effective.\n3.3. Si la construction du véhicule commandé venait à être abandonnée, la vente est résiliée de plein droit",
  'car_config.conditions.2.title': '3. Livraison',
  'car_config.conditions.3.body':
    "4.1 Sans préjudice de l'application de la loi du 12 juin 1991 sur le crédit à la consommation, le Vendeur ne peut demander le paiement d'un acompte supérieur à 15% du prix de vente du véhicule. En dérogation à cette règle, le pourcentage de l'acompte peut être fixé différemment, soit en cas d'accord de l'Acheteur, soit pour des commandes spéciales.\n4.2 Le paiement complet ou celui du solde en cas de paiement d'un acompte se fait au comptant au moment de la livraison, sauf convention expresse contraire. Si le montant dépasse 15 000 €, le paiement sera effectué exclusivement par virement ou par chèque bancaire certifié. A défaut, le solde porte de plein droit et sans mise en demeure un intérêt au taux légal.\nSans préjudice de l'article 3.2., la propriété du véhicule est transférée à l'Acheteur, au moment où le Vendeur a reçu le prix intégral et tous les frais additionnels. L'Acheteur s'interdit jusqu’au moment du paiement entier des biens de vendre ce bien, de le louer, de l'exécuter, de le mettre en gage ou, en particulier, de l'inclure dans un gage sur fond de commerce ou d'en disposer de quelque manière que ce soit, et n'y apportera aucune modification qui pourrait en diminuer la valeur.\nL’acheteur s'engage à entretenir le bien en parfait état. En cas de réalisation d'un véhicule n'ayant pas été complètement payé par l'Acheteur, ce dernier cède de façon automatique et inconditionnelle au Vendeur sa créance sur son débiteur.\nEn outre, si le paiement n'a pas été effectué dans les 10 jours calendrier à dater du dépôt d'une lettre recommandée de mise en demeure, le Vendeur peut résilier la vente par lettre recommandée adressée à l'Acheteur. Dans ce cas, l'Acheteur sera redevable, sans préjudice des intérêts mentionnés ci-dessus, envers le Vendeur, d'une indemnité correspondant au préjudice subi mais limitée à 15% maximum du prix de vente total du véhicule (TVA exclue).\nLa remise d'un chèque ou de tout autre ordre de paiement ne constitue pas un paiement libératoire. L'exécution du paiement aura seulement lieu à la réception effective et complète du montant facturé.\nL'émission d'un chèque non couvert, protêt d'un effet de commerce ou tout autre problème qui empêche le Vendeur de recevoir le paiement du titre qui lui a été remis en paiement, sera considéré par le Vendeur comme une faute lourde qui l'autorise à demander la rupture du contrat, le remboursement immédiat du véhicule et des dommages et intérêts",
  'car_config.conditions.3.title': '4. Paiement',
  'car_config.conditions.4.body':
    "5.1 L'Acheteur reconnaît être informé et accepte le processus évolutif en matière de technique, technologie, production et esthétique dans le secteur automobile, dans le sens que les détails d'un véhicule commandé peuvent être modifiés. Ceux-ci ne peuvent néanmoins pas porter atteinte aux caractéristiques spécifiques et essentielles et à l'usage spécifique recherché par l'Acheteur, comme mentionné au recto du bon de commande.",
  'car_config.conditions.4.title': '5. Conformité de la livraison avec le Contrat',
  'car_config.conditions.5.body':
    "6.1 La garantie conventionnelle\nA. Garantie de base\nLes modalités de la garantie conventionnelle FORD sont reprises dans le Manuel de Garantie, dont l'Acheteur reconnait avoir reçu et accepté le contenu. Cette garantie conventionnelle a une durée de 2 ans pour les véhicules neufs et un an pour les véhicules d'occasion, à compter du jour de livraison.Tout défaut de conformité doit être notifié au Vendeur par courrier recommandé dans un délai de 2 mois, à compter du jour où l'Acheteur a constaté le défaut, et ce sous peine d'irrecevabilité. La pièce défectueuse sera réparée ou remplacée gratuitement par un Réparateur Agréé FORD dans I'EEA, qui utilisera des pièces d'origine FORD. Si, selon le Vendeur, la réparation ou le remplacement s'avère impossible ou disproportionné, il peut procéder à la diminution du prix ou à la résolution de la vente. Néanmoins, la résolution n'est pas possible lorsqu'il s'agit d'un défaut d'importance mineure.Pendant la réparation/remplacement, le délai de garantie est suspendu. Après Quoi, le délai de garantie recommence à courir jusqu'à la fin de la durée initiale.\nCette garantie ne s'applique pas :\n1. à l'usure normale et la diminution de valeur normale de toute pièce, aux opérations normales d'entretien et aux pièces ou matériels utilisés pour cet entretien (voir la description mentionnée dans le Carnet de Service FORD).\n2. au vice provenant d'un accident, d'un usage anormal, négligent ou fautif du véhicule, d'abus, d'une surcharge du véhicule, d'une modification au véhicule ou à une de ses pièces, si une telle modification n'a pas été autorisée ou a été déconseillée par FORD d'un usage à des fins de compétition comme les courses, les rallyes...\n3. au vice résultant du non-respect des prescriptions d'entretien du constructeur (c.-à-d. notamment négligences relatives à la vérification et au contrôle quotidien ou négligences relatives aux périodes d'entretien telles que décrites et spécifiées dans le Carnet de Service FORD, fourni avec te véhicule) ou s'il n'a pas été donné suite aux invitations de vérification technique spécifique (action de rappel).\n4. les dégâts causés par le montage des pièces qui ne sont pas approuvées par FORD ou par l'utilisation de pièces qui n'égalent pas le niveau de qualité des pièces d'origine FORD.\n5. aux pneus ou aux éléments de la carrosserie qui n'ont pas été fabriqués par FORD et dont le véhicule a été équipé.\n6. aux dommages dus à des influences externes (des retombées d'origine industrielle, des excréments d'oiseaux, de la résine, etc.) telles le feu ou les catastrophes naturelles ou causés par la négligence, la faute humaine ou la force majeure.\n7. au vice au catalyseur d'un véhicule, qui doit exclusivement rouler à l'essence sans plomb comme prévu dans le Carnet de Service FORD, suite à l'utilisation d'essence pourvue de plomb. Les travaux exécutés sous garantie doivent être exécutés par un distributeur agréé de la marque.\nB.Garantie Extra\nSi, à côté de la garantie de base mentionnée au point A, l'Acheteur conclut avec le Vendeur un contrat en vue de profiter d'une garantie extra. Cette garantie sera réglée par les dispositions reprises à ce sujet dans le Carnet de Service FORD, livré avec le véhicule. L'Acheteur reconnaît en avoir pris connaissance et les avoir acceptées.\nC.Garantie contre la perforation par la corrosion\nLe Vendeur garantit que si l'une ou l'autre pièce de la carrosserie du véhicule vient à être perforée de l'intérieur vers l'extérieur par la rouille, dans le délai précisé dans le Carnet de Service FORD à compter de la date à laquelle le véhicule a été livré à son premier propriétaire, ladite pièce sera remplacée ou réparée gratuitement par un distributeur FORD agréé. Les conditions, exclusions et obligations concernant cette garantie sont mentionnées dans le Carnet de Service FORD, livré avec le véhicule. L'Acheteur déclare en avoir pris connaissance et les avoir acceptées.\n6.2 Garantie légale\nLa garantie conventionnelle ne porte pas atteinte aux droits de l'Acheteur concernant la garantie légale pour défaut de conformité. Le délai de garantie légale est néanmoins limité à un an pour les véhicules d'occasion et l'Acheteur doit notifier chaque défaut de conformité au Vendeur par pli recommandé dans un délai de 2 mois après l'avoir constaté.La garantie conventionnelle ne porte pas atteinte aux droits de l'Acheteur concernant la garantie pour vices cachés, après l'expiration de la garantie légale pour défaut de conformité. Tout vice caché doit néanmoins être notifié par ('Acheteur au Vendeur par pli recommandé dans un délai de 2 mois après qu'il ait constaté ou aurait dû constater le vice caché, Passés ces délais, aucune plainte ne sera acceptée.",
  'car_config.conditions.5.title': '6. Conformité du véhicule',
  'car_config.conditions.6.body':
    "7.1. Le cas échéant, le financement s'applique conformément à la loi du 12 juin 1991 relative au crédit à la consommation, et particulièrement à son article 18 qui concerne la faculté de renonciation.\nSi la vente a été conclue sous condition suspensive de l'octroi d'un financement, sans intervention du Vendeur quant à ce financement et si ce financement est refusé par l'établissement de crédit, l'Acheteur devra en aviser sans délai le Vendeur. De plus, la preuve écrite de ce refus de financement devra être rapportée par lettre adressée au Vendeur dans le mois de la signature du bon -de commande. L'acompte éventuellement versé sera, dans ce cas, remboursé immédiatement à l'Acheteur. Si l'Acheteur ne respecte pas la procédure susvisée, le Vendeur pourra lui réclamer une indemnité limitée à du prix de vente du véhicule (TVA exclue).\n7.2. Si la vente est conclue sous condition suspensive de l'octroi d'un financement, le délai ou la date de livraison est donné à titre purement indicatif. Après communication de l'octroi du financement, les parties devront conclure un accord définitif quant à la date ou au délai de livraison.\n7.3. Les ventes dans les salons, foires et expositions, pour autant que le paiement n'ait pas lieu au comptant, sont de plus régies par les articles 86 et suivants de la loi du 14 juillet 1991 sur les pratiques du commerce et sur l'information et la protection du consommateur, avec le délai de réflexion prévu à l'article 89 de cette loi.",
  'car_config.conditions.6.title': '7. Financement et faculté de renonciation',
  'car_config.conditions.7.body':
    "Lorsque le bon de commande stipule la reprise d'un véhicule d'occasion, cette reprise est subordonnée à la livraison et au paiement d'un véhicule neuf et à la preuve que l'Acheteur est propriétaire du véhicule à reprendre et que toutes les obligations afférentes à son financement éventuel ont été exécutées. La valeur de reprise du véhicule d'occasion, convenue lors de la commande du véhicule neuf est définitive pour autant que l'état du véhicule d'occasion, au moment de sa livraison par l'Acheteur soit, à l'exception de détails minimes et non essentiels pour le Vendeur, entièrement conforme à la description qui en a été faite dans le bon de commande.",
  'car_config.conditions.7.title': "8. Reprise d'un véhicule d'occasion",
  'car_config.conditions.8.body':
    'Tout document émanant du constructeur, mentionnant les caractéristiques du véhicule commandé, portant le cachet ou la signature du Vendeur, et joint au bon de commande, est réputé faire partie du bon de commande auquel il est joint.',
  'car_config.conditions.8.title': '9. Documents du constructeur',
  'car_config.conditions.9.body':
    "Aucune indemnité et aucun dommages et intérêts ne seront dus lorsque l'annulation ou la résiliation est due à la force majeure. La partie qui invoque un cas de force majeure en avertit l'autre dans les huit jours de la prise de connaissance du fait, et ce par lettre recommandée.",
  'car_config.conditions.9.title': '10. Force majeure',
  'car_config.conditions.10.body':
    "Dans les dispositions précédentes, la forme « recommandé » de l'écrit n'a qu'une valeur de preuve.",
  'car_config.conditions.10.title': '11. Preuve',
  'car_config.conditions.11.body':
    "En cas de litige, les juges suivants sont, au choix du demandeur, compétents pour connaître de l'action :\n1. le juge du domicile du défendeur ou d'un des défendeurs :\n2. le juge du lieu où les obligations en litige ou l'une d'entre elles sont nées ou le juge du lieu où ces obligations ont été, sont ou doivent être exécutées ;\n3. le juge du domicile de l'Acheteur\nCe contrat est soumis au droit belge, à l'exclusion des dispositions du Traité de Vienne du 11 avril 1980. Les tribunaux belges sont uniquement compétents.",
  'car_config.conditions.11.title': '12. Tribunal compétent',
  'car_config.conditions.12.body':
    "Le traitement des données personnelles appartient à la sphère privée. Les données personnelles que nous récoltons vous concernant seront utilisées pour exécuter le contrat éventuel relatif à votre véhicule Ford et peuvent être utilisées à des fins de vente, après-vente, garantie, sécurité et gestion de la clientèle. Ces informations ne seront pas communiquées à des tiers en dehors de \"Ford Motor Company Group\", ses filiales ou sociétés liées, agents, concessionnaires ou détenteurs de licences, ou toute autre société avec qui FORD MOTOR COMPANY (BELGIUM) SA a convenu une prestation de service à votre avantage, ainsi que tout cessionnaire, préposé ou remplaçant des parties précitées. Vos données seront initialement traitées et sauvegardées par FORD MOTOR COMPANY (BELGIUM) SA, Avenue du Hunderenveld 10, 1082 Bruxelles, et pourront être transférées vers d'autres Etats, à l'intérieur ou en dehors de l’union Européenne, où elles pourront également être traitées et sauvegardées. Moyennant identification, vous êtes habilité en tant qu'individu à demander quelles informations vous concernant nous avons sauvegardées et à effectuer des adaptations si nécessaire, Pour ce faire, vous pouvez prendre contact avec FORD MOTOR COMPANY (BELGIUM) SA, Avenue du Hunderenveld 10.1082 Bruxelles.",
  'car_config.conditions.12.title': '13. Protection de la vie privée',
  'car_config.conditions.13.body':
    "14.1. Les présentes conditions générales sont intégralement d'application pour autant que l'Acheteur soit un consommateur au sens de la loi du 14 juillet 1991 sur les pratiques du commerce et sur l'information et la protection du consommateur, c'est-à-dire pour autant qu'il acquière ou utilise le véhicule faisant l'objet du présent contrat de vente à des fins excluant tout caractère professionnel.\n14.2. Dans tous les cas où l'Acheteur n'est pas un consommateur au sens de l'article ci-dessus, les présentes conditions générales s'appliquent à l'exception des articles suivants : 1.1.,2.1., 2.2., 2.3., 4.1., 6.2., 7.1., 7.2., 7.3., 9 et 12.\nEn pareil cas :\n1. la date ou le délai de livraison est toujours donné à titre purement indicatif et sans engagement ferme du Vendeur ;\n2. les prix indiqués au recto du contrat de vente sont susceptibles d'être augmentés en cas de modification du prix catalogue conseillé par l'importateur ou le producteur ;\n3. les juges du domicile ou du siège social du Vendeur sont exclusivement compétents :\n4. les défauts apparents à la peinture, à la carrosserie et aux garnitures d'intérieur doivent être signalés par l'Acheteur au Vendeur sans délai et par courrier recommandé. Tout autre vice apparent doit être notifié par l'Acheteur au Vendeur par courrier recommandé au plus tard dans les 10 jours calendrier à partir de la livraison, et ce sous peine d'irrecevabilité :\n5. l'Acheteur doit notifier chaque vice caché au Vendeur par courrier recommandé, dans un délai d'un mois à partir du moment où il a constaté ou aurait normalement dû constater le défaut, et ce sous peine d'irrecevabilité.",
  'car_config.conditions.13.title': "14. Qualité de l'Acheteur",
  'car_config.conditions.14.body': '',
  'car_config.conditions.14.title': '',
  'car_config.configuration.accessories': 'Accessoires',
  'car_config.configuration.additional_options': 'Total Options Additionnelles',
  'car_config.configuration.address': 'Addresse: {0}',
  'car_config.configuration.catalogPrice': 'Prix catalogue',
  'car_config.configuration.comment': 'REMARQUES:',
  'car_config.configuration.contact': 'Contact: {0}',
  'car_config.configuration.date': 'Date: {0}',
  'car_config.configuration.deliveryDate': 'Date de livraison',
  'car_config.configuration.deliveryTime': 'Délai de livraison:',
  'car_config.configuration.destination': 'Offre à destination de',
  'car_config.configuration.discounts': 'Total Remises',
  'car_config.configuration.driver': 'Driver: {0}',
  'car_config.configuration.end1':
    "Cette offre est faite sans aucun engagement du client et ne peut en aucun cas être considérée comme une commande. Seul un bon de commande signé par le client vaut commande. Le distributeur se réserve le droit, en cas de commande du client, d'adapter les conditions reprises dans la présente offre à des éventuels changements de circonstances, tels que changement dans le délai de livraison ou du prix tarif.",
  'car_config.configuration.end2':
    "Vos données seront enregistrées dans notre fichier afin de vous tenir informé de nos activités. Vous pouvez à tout moment nous demander de consulter, modifier ou même faire effacer vos données. Vos données peuvent être transmises â d'autres sociétés (telles que partenaires commerciaux, secteurs caritatifs ou groupements d'interêt ou d'opinion) qui vous enverront des offres promotionnelles personnalisées. Si vous ne le souhaitez pas, cochez la case ci-après",
  'car_config.configuration.finalPrice': 'PRIX FINAL',
  'car_config.configuration.garage': 'Garage: {0}',
  'car_config.configuration.leaser': 'Leaser: {0}',
  'car_config.configuration.mail': 'Mail: {0}',
  'car_config.configuration.marketValue': '{0} {1} (TVA: {2})',
  'car_config.configuration.netPrice': 'Prix Net TVA comprise',
  'car_config.configuration.options': 'Total Options',
  'car_config.configuration.phone': 'Tel: {0}',
  'car_config.configuration.printSpecs': 'Imprimer les spécifications',
  'car_config.configuration.purchaseOrder': 'BON DE COMMANDE',
  'car_config.configuration.reference': 'Reference: {0}',
  'car_config.configuration.salesAdvisor': 'Conseiller commercial',
  'car_config.configuration.totalPrice': 'PRIX TOTAL',
  'car_config.configuration.totalWithoutDiscount': 'PRIX TOTAL AVANT REMISE',
  'car_config.configuration.tradeIn': 'Reprise',
  'car_config.configuration.tradeInOffer': 'Prime de reprise ({0})',
  'car_config.configuration.validUntil': "Offre valide jusqu'au: {0}",
  'car_config.configuration.vat': 'TVA',
  'car_config.configuration.vatExc': 'HTVA',
  'car_config.configuration.vatInc': 'TVAC',
  'car_config.contract.0.body':
    "{0}, avec son siège social à {1}, et avec numéro BCE (le'Concessionnaire Ford') souhaite vous envoyer les informations sur les produits et services du groupe Ford Motors, y compris les offres qui correspondent à vos intérêts (comme des parcours d’essais, des invitations pour le lancement de nouveaux modèles, des offres spéciales). Acceptez-vous de recevoir ces informations de votre Concessionnaire Ford:",
  'car_config.contract.0.title': '1. Informations de votre Concessionnaire Ford',
  'car_config.contract.1.body':
    'L’importateur de véhicules Ford en Belgique, Ford Motors Company (1082 Bruxelles, Av. de Hunderenveld 10, RPM Bruxelles, numéro BE 0404.955.204) souhaite également vous envoyer des informations concernant les produits et services du groupe Ford Motors Company.',
  'car_config.contract.1.body2':
    'Si vous consentez à ce que Ford Motors Company utilise vos données à caractère personnel (nom, coordonnées, adresse, caractéristiques personnelles telles que l’âge, la date de naissance et le sexe) afin de vous faire parvenir des informations sur les produits et services du groupe Ford Motors Company, y compris les offres qui correspondent à vos intérêts (comme des parcours d’essais, des invitations pour le lancement de nouveaux modèles, des offres spéciales chez Ford Motors Company et/ou chez le Concessionnaire Ford), veuillez indiquer si vous acceptez d’être contacté:',
  'car_config.contract.1.title': '2. Informations de Ford Belux SA',
  'car_config.contract.2.body1':
    'a. Vous pouvez toujours retirer votre consentement pour l’utilisation de vos données dans le cadre du marketing direct en contactant le Concessionnaire Ford. Cela peut se faire par simple demande écrite à l’entreprise concernée, qui intervient chaque fois en tant que responsable du traitement (chacun d’entre eux est un « Responsable »), ou par e-mail à {0}. Le retrait de votre consentement n’aura pas d’impact sur la légalité de l’utilisation de vos données avant le retrait.',
  'car_config.contract.2.body2':
    'b. Conformément au RGPD, vous avez le droit, à l’égard de chaque Responsable concerné de (i) demander au Responsable l’accès et la rectification ou l’effacement de vos données à caractère personnel qu’il traite, (ii) demander au Responsable de limiter le traitement de données vous concernant, et le droit de vous opposer au traitement, (iii) demander au Responsable de recevoir les données à caractère personnel que vous lui avez communiquées dans un format structuré, couramment utilisé et lisible par machine pour pouvoir les faire parvenir à d’autres Responsables de traitement, et (iv) déposer une plainte auprès de l’autorité de surveillance. Vos données à caractère personnel sont traitées par le Responsable concerné aussi longtemps que nécessaire pour la finalité concernée, mais au maximum [5] ans après le dernier contact avec le Responsable concerné, à moins qu’un autre délai de conservation ne soit légalement requis.',
  'car_config.contract.2.body3':
    'c. Le DPO (“délégué à la protection des données”) de Ford peut être contacté à l’adresse suivante {0}.',
  'car_config.contract.2.body4':
    'd. Nous vous avons remis également notre « Notification générale concernant le Traitement des Données à Caractère Personnel » dans laquelle vous trouverez plus d’informations sur la façon dont nous traitons vos données à caractère personnel.',
  'car_config.contract.2.title': '3. Vos droits',
  'car_config.contract.sign': 'Signature',
  'car_config.contract.sign.condition': '(Signature des deux parties, précédée de la mention "Lu et approuvé")',
  'car_config.export_modal.body':
    "Les données des offres vont être exportées sous format Excel. Merci d'indiquer votre adresse mail pour recevoir le fichier.\nCette opération peut prendre plusieurs minutes.",
  'car_config.export_modal.export_error': "Une erreur est survenue lors de l'export des offres.",
  'car_config.export_modal.export_success':
    "Export en cours. Veuillez consulter votre boîte mail d'ici quelques instants.",
  'car_config.export_modal.title': 'Exporter les données',
  'car_config.standardFeatures.title': 'Equipement de série {0}',
  'car_config.tradeIn.accessories': 'Total Accessoires',
  'car_config.tradeIn.battery': 'Batterie:',
  'car_config.tradeIn.brand': 'Marque:',
  'car_config.tradeIn.car': 'Voiture achetée:',
  'car_config.tradeIn.carCondition': 'Indiquez les parties endommagées:',
  'car_config.tradeIn.careDate': 'Date du dernier passage:',
  'car_config.tradeIn.careDone': "Carnet d'entretien:",
  'car_config.tradeIn.color': 'Couleur du véhicule:',
  'car_config.tradeIn.comment': 'Commentaire:',
  'car_config.tradeIn.contract.body':
    'Le soussigné M/Mme {0} déclare être le propriétaire du véhicule sur lequel ne repose aucune réserve de propriété, correspondant à la description ci-dessus et dont le kilométrage actuel est de {1} km. ll/elle sengage à fournir le véhicule dans létat décrit ci-dessus. Le vendeur déclare reprendre le véhicule décrit en annexe. Montant de la reprise (TVAC): {2}',
  'car_config.tradeIn.cylinder': 'Cylindrée:',
  'car_config.tradeIn.damage': 'Descriptif des dégâts:',
  'car_config.tradeIn.fuel': 'Carburant:',
  'car_config.tradeIn.horsePower': 'Chevaux fiscaux:',
  'car_config.tradeIn.inspectionDate': 'Date du dernier passage:',
  'car_config.tradeIn.inspectionDone': 'Contrôle technique:',
  'car_config.tradeIn.kw': 'kW:',
  'car_config.tradeIn.mechanics': 'Mécaniques et accessoires',
  'car_config.tradeIn.mileage': 'Kilométrage:',
  'car_config.tradeIn.model': 'Type:',
  'car_config.tradeIn.other': 'Autre(s):',
  'car_config.tradeIn.plate': "Plaque d'immatriculation:",
  'car_config.tradeIn.radio': 'Radio:',
  'car_config.tradeIn.ratings': '1 =  Bon 2 =  Moyen 3 =  Mauvais',
  'car_config.tradeIn.seen': 'Avez-vous vu le véhicule:',
  'car_config.tradeIn.sign.approvement': 'Lu et approuvé',
  'car_config.tradeIn.sign.customer': 'SIGNATURE CLIENT',
  'car_config.tradeIn.sign.date': 'Le {0}',
  'car_config.tradeIn.sign.dealership': 'SIGNATURE CONCESSIONNAIRE',
  'car_config.tradeIn.sign.place': 'Fait à {0}',
  'car_config.tradeIn.table.absorber': 'Amortisseurs',
  'car_config.tradeIn.table.afterdeck': "Pont arrière d'injection",
  'car_config.tradeIn.table.alternator': 'Alternateur',
  'car_config.tradeIn.table.brakes': 'Freins',
  'car_config.tradeIn.table.clutch': 'Embrayage',
  'car_config.tradeIn.table.direction': 'Direction',
  'car_config.tradeIn.table.disc': 'Disques',
  'car_config.tradeIn.table.foredeck': 'Pont avant',
  'car_config.tradeIn.table.gearbox': 'Bte vitesse',
  'car_config.tradeIn.table.handbrake': 'Frein à main électrique',
  'car_config.tradeIn.table.lights': 'Feux hydraulique',
  'car_config.tradeIn.table.noseGear': 'Train avant',
  'car_config.tradeIn.table.oil': "Cons. d'huile",
  'car_config.tradeIn.table.relay': 'Relais',
  'car_config.tradeIn.table.starter': 'Démarreur',
  'car_config.tradeIn.table.suspension': 'Suspension',
  'car_config.tradeIn.table.transmission': 'Transmission',
  'car_config.tradeIn.table.wiper': 'Essuie-glaces',
  'car_config.tradeIn.tires': 'Pneus:',
  'car_config.tradeIn.transmission': 'Transmission:',
  'car_config.tradeIn.vin': 'Numéro de chassis:',
  'car_config.tradeIn.welding': 'Soudure:',
  'car_config.tradeIn.year': 'Année de construction:',
  'checklists.first_offer': 'Offer 1',
  'checklists.first_vehicle': 'Vehicle 1',
  'checklists.new_offer': 'New offer',
  'civility.dear.company': 'To the attention of',
  'civility.dear.miss': 'Dear',
  'civility.dear.mr': 'Dear',
  'civility.dear.ms': 'Dear',
  'civility.default': 'Dear Sir or Madam',
  'civility.greeting': 'Hello',
  'civility.greetings':
    '{civility, select, company {To the attention of {companyName},{br}Dear Sir or Madam} miss {Dear Miss {lastName}} mr {Dear Mr {lastName}} ms {Dear Ms {lastName}} other {Dear Sir or Madam}}',
  'civility.miss': 'Miss',
  'civility.mr': 'Mr',
  'civility.ms': 'Ms',
  'civility.none': 'Other',
  'common.customer': 'Customer',
  'common.dealership': 'This dealership',
  'common.error': 'Error',
  'common.fleetback': 'Fleetback',
  'common.missing.translation': 'Missing translation',
  'common.no': 'No',
  'common.ok': 'OK',
  'common.outdated': 'outdated',
  'common.upgrade.your.browser': 'upgrade your browser',
  'common.upgrade.your.web.browser.1': 'You are using an',
  'common.upgrade.your.web.browser.2': 'browser. Please',
  'common.upgrade.your.web.browser.3': 'to improve your experience.',
  'common.yes': 'Yes',
  'common.you': 'You',
  'contact.address': 'Address:',
  'contact.confidentiality.policy': 'Confidentiality policy',
  'contact.email': 'Email:',
  'contact.fax': 'Fax:',
  'contact.general.terms.conditions': 'General terms and conditions',
  'contact.legal.notice': 'Legal notice',
  'contact.social_networks.FACEBOOK': 'Facebook',
  'contact.social_networks.INSTAGRAM': 'Instagram',
  'contact.social_networks.LINKEDIN': 'LinkedIn',
  'contact.social_networks.X': 'X',
  'contact.social_networks.YOUTUBE': 'Youtube',
  'contact.tel': 'Tel:',
  'contact.website': 'Website:',
  'country.andorra': 'Andorra',
  'country.angola': 'Angola',
  'country.austria': 'Austria',
  'country.belgium': 'Belgium',
  'country.cap_verde': 'Cap Verde',
  'country.colombia': 'Colombia',
  'country.czech_republic': 'Czech Republic',
  'country.denmark': 'Denmark',
  'country.finland': 'Finland',
  'country.france': 'France',
  'country.germany': 'Germany',
  'country.guadeloupe': 'Guadeloupe',
  'country.italy': 'Italy',
  'country.kenya': 'Kenya',
  'country.latvia': 'Latvia',
  'country.liechtenstein': 'Liechtenstein',
  'country.luxembourg': 'Luxembourg',
  'country.monaco': 'Monaco',
  'country.mozambique': 'Mozambique',
  'country.netherlands': 'Netherlands',
  'country.new_zealand': 'New Zealand',
  'country.norway': 'Norway',
  'country.other': 'Other',
  'country.peru': 'Peru',
  'country.poland': 'Poland',
  'country.portugal': 'Portugal',
  'country.senegal': 'Senegal',
  'country.south_africa': 'South Africa',
  'country.spain': 'Spain',
  'country.sweden': 'Sweden',
  'country.switzerland': 'Switzerland',
  'country.uk': 'United Kingdom',
  'country.ukraine': 'Ukraine',
  'country.usa': 'United States of America',
  'dealer.checklist.index_invalid': 'The checklist index is invalid.',
  'dealer.checklist.name_is_empty': 'The checklist name is null or empty.',
  'dealer.checklist.name_not_unique': 'The checklist name is not unique.',
  'dealer.configuration_is_null': 'No configuration exists currently.',
  'dealer.id_not_found': 'The dealership with the identifier: {0} could not be found.',
  'default_message.default': 'Go back to my check-out',
  'device.target.fleetback.name': 'Fleetback App',
  'device.target.oditoo.name': 'Fleetback Oditoo',
  'email.accept_manually.link': 'Take me to my file',
  'email.accept_manually.offer.message': 'We registered your decision. Your file is available by clicking hereafter:',
  'email.accept_manually.title': 'Confirmation of your decision {0}',
  'email.aftersales.customer.answered.message':
    'Thank you for responding to the additional works recommended on your vehicle. Your request has been taken into account.',
  'email.appointment.accepted_documents.message':
    '{0} {1} has just accepted the proposed documents. <a href="{2}">Click here to view them.</a>',
  'email.appointment.accepted_documents.message_default':
    'Your customer has just accepted the proposed documents. <a href="{0}">Click here to view it.</a>',
  'email.appointment.accepted_documents.title': '{@productName} - [{0}] - Proposed documents accepted',
  'email.appointment.accepted_works.message':
    '{0} {1} has just accepted the proposed works. <a href="{2}">Click here to view them.</a>',
  'email.appointment.accepted_works.message_default':
    'Your customer has just accepted the proposed works. <a href="{0}">Click here to view them.</a>',
  'email.appointment.accepted_works.title': '{@productName} - [{0}] - Proposed works accepted',
  'email.appointment.action_required.message':
    'A problem has just been reported while checking the safe for {0} {1}\'s appointment. <a href="{2}">Click here to view it.</a>',
  'email.appointment.action_required.message_default':
    'A problem has just been reported during the safe verification. <a href="{0}">Click here to view it.</a>',
  'email.appointment.action_required.title':
    '{@productName} - [{0}] - A problem while checking the safe has just been reported',
  'email.appointment.at': 'Appointment at',
  'email.appointment.completed_by_technician.message':
    '<p>A new appointment has just been created by {0} on the {1}. <a href="{2}">Click here to view it.</a></p>',
  'email.appointment.completed_by_technician.title': '{@productName} - [{0}] - A new appointment is available',
  'email.appointment.email_send_issue.message':
    '<p>The appointment sent at {0} contains a valid email but could not be delivered to the customer by email. Please verify the <a href="{1}">appointment</a>.</p>',
  'email.appointment.email_send_issue.title': '{@productName} - [{0}] - Appointment with a non delivered email',
  'email.appointment.invalid_email.message':
    '<p>The appointment sent at {0} contains an invalid email. Please verify the <a href="{1}">appointment</a>.</p>',
  'email.appointment.invalid_email.title': '{@productName} - [{0}] - Appointment with an invalid email',
  'email.appointment.issues.client_keys_missing': "Client's key are missing",
  'email.appointment.issues.client_keys_unused': "Client's key are still in the safe",
  'email.appointment.issues.expired_dropoff_booking': 'Booking reservation period expired',
  'email.appointment.issues.expired_pickup_booking': 'Booking reservation period expired',
  'email.appointment.issues.rental_keys_missing': 'Rental vehicle key are missing',
  'email.appointment.issues.rental_keys_unused': 'Rental vehicle key are still in the safe',
  'email.appointment.locker_preparation_reminder.message':
    '{0} {1}\'s appointment will start at {2}. <a href="{3}">Click here to prepare the safe.</a>',
  'email.appointment.locker_preparation_reminder.message_default':
    'The {0} appointment is about to begin. <a href="{1}">Click here to prepare the safe.</a>',
  'email.appointment.locker_preparation_reminder.title': '{@productName} - [{0}] - Please prepare the safe',
  'email.appointment.locker_verification.key_deposit.message':
    '{0} {1} has just completed its key drop off. <a href=" {2}">Click here to check the safe</a>.</p>',
  'email.appointment.locker_verification.key_deposit.message_default':
    'Your customer has just completed their key drop off. <a href=" {0}">Click here to check the safe</a>.</p>',
  'email.appointment.locker_verification.key_deposit.title': '{@productName} - [{0}] - Please check the safe',
  'email.appointment.locker_verification.key_retrieve.message':
    '{0} {1} has just completed its key pick up. <a href=" {2}">Click here to check the safe.</a>',
  'email.appointment.locker_verification.key_retrieve.message_default':
    'Your customer has just completed their key pick up. <a href=" {0}">Click here to check the safe.</a>',
  'email.appointment.locker_verification.key_retrieve.title': '{@productName} - [{0}] - Please check the safe',
  'email.appointment.locker_verification_reminder.message':
    '{0} {1}\'s appointment has just ended. <a href="{2}">Click here to check the safe.</a>',
  'email.appointment.locker_verification_reminder.message_default':
    'An appointment has just ended. <a href="{0}">Click here to check the safe.</a>',
  'email.appointment.locker_verification_reminder.title': '{@productName} - [{0}] - Please check the safe',
  'email.appointment.new_document.message':
    '{0} {1} has just added a new document. <a href="{2}">Click here to view it.</a>',
  'email.appointment.new_document.message_default':
    'Your customer has just added a new document. <a href="{0}">Click here to view it.</a>',
  'email.appointment.new_document.title': '{@productName} - [{0}] - A document has just been added',
  'email.appointment.new_message.message':
    '{0} {1} has just sent a new message. <a href="{2}">Click here to view it.</a>',
  'email.appointment.new_message.message_default':
    'Your customer has just sent a new message. <a href="{0}">Click here to view it.</a>',
  'email.appointment.new_message.title': '{@productName} - [{0}] - You have a new message',
  'email.appointment.refused_documents.message':
    '{0} {1} has just refused the proposed documents. <a href="{2}">Click here to view them.</a>',
  'email.appointment.refused_documents.message_default':
    'Your customer has just refused the proposed documents. <a href="{0}">Click here to view it.</a>',
  'email.appointment.refused_documents.title': '{@productName} - [{0}] - Proposed documents have been refused',
  'email.appointment.refused_works.message':
    '{0} {1} has just refused the proposed works. <a href="{2}">Click here to view them.</a>',
  'email.appointment.refused_works.message_default':
    'Your customer has just refused the proposed works. <a href="{0}">Click here to view them.</a>',
  'email.appointment.refused_works.title': '{@productName} - [{0}] - Proposed works have been refused',
  'email.appointment.rental_issues.message':
    '{0} {1} has just reported a problem with the rental vehicle. <a href="{2}">Click here to view it.</a>',
  'email.appointment.rental_issues.message_default':
    'Your customer has just reported a problem with the rental vehicle. <a href="{0}">Click here to view it.</a>',
  'email.appointment.rental_issues.title':
    '{@productName} - [{0}] - A problem with the rental vehicle has just been reported',
  'email.appointment.rental_signed.message':
    '{0} {1} just signed the rental car documents. <a href="{2}">Click here to view them.</a>',
  'email.appointment.rental_signed.message_default':
    'Your customer has just signed the rental car documents. <a href="{0}">Click here to view it.</a>',
  'email.appointment.rental_signed.title': '{@productName} - [{0}] - Rental car documents have been signed',
  'email.appointment.reopened.message':
    'An appointment has been unarchived and is available at this address: <a href="{0}">Click here to view it.</a>',
  'email.appointment.reopened.title': '{@productName} - [{0}] - Appointment unarchived',
  'email.appointment.vault.title': '{@productName} - [{0}] - New event of the safe',
  'email.appointment.vault_opened.message': '{0} {1} has opened the safe. <a href="{2}">Click here to view it.</a>',
  'email.appointment.vault_opened.message_default':
    'Your customer has opened the safe. <a href="{0}">Click here to view it.</a>',
  'email.appointment.vault_prepared.message': 'The safe has been prepared. <a href="{0}">Click here to view it.</a>',
  'email.appointment.vault_verified.message': 'The safe has been verified. <a href="{0}">Click here to view it.</a>',
  'email.audit.share.subject': '{@productName} - [{0}] shares an audit with you',
  'email.audit_completed.message':
    '<p>An audit has been completed by {0} on {1} and is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.audit_completed.title': '{@productName} - [{0}] - Audit completed',
  'email.audit_created.message':
    '<p>A new audit has been created by {0} on {1} and is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.audit_created.no_reference.title': '{@productName} - New audit available',
  'email.audit_created.title': '{@productName} - [{0}] - New audit available',
  'email.audit_duplicated.message':
    '<p>A new audit has been duplicated by {0} on {1} and is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.audit_duplicated.title': '{@productName} - [{0}] - Audit duplicated',
  'email.audit_email_send_issue.message':
    '<p>The audit sent at {1} contains a valid email but could not be delivered to the customer by email. Please verify the <a href="{2}">audit</a> .</p>',
  'email.audit_email_send_issue.title': '{@productName} - [{0}] - Audit sent with a non delivered email',
  'email.audit_invalid_email.message':
    '<p>The audit sent on {1} contained an invalid email. Please send the <a href="{2}">audit</a> with a valid email.</p>',
  'email.audit_invalid_email.title': '{@productName} - [{0}] - Audit sent with an invalid email',
  'email.audit_invalid_kpi.message':
    '<p>An audit has been completed by {0} on {1} with an invalid KPI response. The audit is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.audit_invalid_kpi.title': '{@productName} - [{0}] - Audit completed with an invalid KPI response',
  'email.audit_kpi_answered.message':
    '<p>An answer to a KPI question was added to audit by {0} on {1} and is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.audit_kpi_answered.title': '{@productName} - [{0}] - Audit completed with KPI response',
  'email.audit_reopened.message':
    '<p>A new audit has been unarchived by {0} on {1} and is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.audit_reopened.title': '{@productName} - [{0}] - Audit unarchived',
  'email.auditStatistics.export.body':
    '<p>The statistics export for the audit model <b>{1}</b>, from <b>{2}</b> to <b>{3}</b>, for <b>{0}</b> is available.</p>',
  'email.auditStatistics.export.subject': '{@productName} - Statistics export',
  'email.auditStatistics.export.title': 'Your statistics export is here !',
  'email.automatic_resend':
    'We remind you to consult the additional information concerning your vehicle by clicking the following link:',
  'email.best.regards': 'Best Regards.',
  'email.billingStatistics.export.body':
    'The statistics export of the usage metrics from <b>{0}</b> to <b>{1}</b> for <b>{2}</b> is available.',
  'email.billingStatistics.export.body.brand-manager':
    'The statistics export of the usage metrics from <b>{0}</b> to <b>{1}</b> is available.',
  'email.billingStatistics.export.dealerName': 'dealer name',
  'email.billingStatistics.export.group': '{0} group',
  'email.billingStatistics.export.groups': 'all your groups',
  'email.billingStatistics.export.smsCount': 'sms',
  'email.billingStatistics.export.subject': '{@productName} - Statistics export',
  'email.billingStatistics.export.title': 'Your statistics export is here !',
  'email.body.mfa.code': 'Here is your authentication code: {code}',
  'email.campaign.adviceButton': 'Order',
  'email.campaign.customer.answered.message': 'Thank you for responding. Your request has been taken into account.',
  'email.campaign.mediaSection': 'Media',
  'email.campaign.multipleOffers.link': '<b>Please find all offers via the following link:</b><br>{0}',
  'email.campaign.multipleOffers.viewAll': 'View complete offer ({0} items})',
  'email.campaign.oldPrice': '<s><b class="price">{0}</b> incl. tax</s>',
  'email.campaign.price': '<p><b class="price">{0}</b> incl. tax</p>',
  'email.campaign.singleOffer.link': '<b>Please find the complete file via the following link:</b>',
  'email.campaign.singleOffer.title': '<b>Items</b> ({0} of {1})',
  'email.campaign.singleOffer.viewAll': 'View all ({0})',
  'email.campaign.unsubscribe':
    'This e-mail has been sent to {0}, <a href="{1}" target=_blank>click here to unsubscribe.</a>',
  'email.campaign_result.export.body': 'The results for the campaign {campaignName} until {date} are available',
  'email.campaign_result.export.title': 'Your campaign results are here!',
  'email.chat.message.body': 'The {dealer} team sent you a new message: {content}',
  'email.chat.message.link': 'See my message',
  'email.chat.message.title': 'New message available',
  'email.chatbot.message':
    '[{0}] Prepare your appointment by following one of the following links: {1} if you use Messenger or {2}',
  'email.client.notification.conversation.new_message.message':
    '<b>{0}</b> from <b>{1}</b> dealership sent you a message:<br> <blockquote>{2}</blockquote>',
  'email.client.notification.conversation.new_message.title': '<b>{0}</b> - A message has been received',
  'email.client.notification.friendly.from': '{0} via Fleetback',
  'email.client.notification.manual.acceptation.subject': '[{0}] Confirmation of your decision on additional works',
  'email.client.notification.sales.subject': '[{0}] Complementary information on a vehicle',
  'email.client.notification.tech.subject': '[{0}] Follow up on your visit in our workshop',
  'email.client.notification.tech.subject.with.time':
    '[{0}] Follow up on your visit in our workshop - Answer expected before {1}',
  'email.contact_list.button': 'Go to the contact list',
  'email.contact_list.button_csv': 'Download csv error file',
  'email.contact_list.export.body': 'The contact list {contactListName} for {dealerName} on {date} is available.',
  'email.contact_list.export.title': 'Your contact list export is here!',
  'email.contact_list.message_failure':
    'Unfortunately, some of the contacts in the list could not be processed. You can find these erroneous contacts in the csv file below.<br /><br />Number of contact in the list: <b>{contacts} contacts</b>',
  'email.contact_list.message_success': 'Number of contact in the list: <b>{contacts} contacts</b>',
  'email.contact_list.title_failure': 'Contact list "{name}" was updated',
  'email.contact_list.title_success': 'Contact list "{name}" was successfully updated',
  'email.contact_list.unsubscribe.body':
    'The customer, {customerName}, has unsubscribed from marketing communications on {date}.',
  'email.contact_list.unsubscribe.title': 'The customer has unsubscribed from marketing communications',
  'email.conversation_created.message': 'A new conversation was created by {0} on {1} in the following link: {2}',
  'email.conversation_created.title': '{@productName} - [{0}] - New conversation created',
  'email.conversation_message_created.file.message':
    'A new message has been sent by {0} on {1} in the following file: {2}',
  'email.conversation_message_created.file.title': '{@productName} - [{0}] - New message received',
  'email.conversation_message_created.message':
    'A new message has been sent by {0} on {1} in the following conversation: {2}',
  'email.conversation_message_created.title': '{@productName} - [{0}] - New message received',
  'email.customer': 'The customer',
  'email.customer.answered.link.prefix': 'You can find your complete file by following the link below:',
  'email.customer.answered.prefix': 'Please find below a summary of your answer:',
  'email.customer.answered.subject': 'Answer confirmation',
  'email.customer.answered.title': 'Answer confirmation - {0}',
  'email.customer.answered.translations.accepted': 'Accepted',
  'email.customer.answered.translations.answer': 'Answer',
  'email.customer.answered.translations.name': 'Name',
  'email.customer.answered.translations.offered': 'Offered',
  'email.customer.answered.translations.priceWithoutVAT': 'Price excl. tax',
  'email.customer.answered.translations.priceWithVAT': 'Price incl. tax',
  'email.customer.answered.translations.refused': 'Refused',
  'email.customer.answered.translations.totalAccepted': 'Total accepted',
  'email.customer.replied.sms.notification.message':
    '<p>The customer has replied to SMS notification on {0}.</p><p>The customer\'s reply is: <blockquote><i>"{1}"</i></blockquote></p><p>The file is available at this address: <a href="{2}">{2}</a></p>',
  'email.customer.replied.sms.notification.message.company':
    '<p>The customer, <b>{0}</b>, has replied to SMS notification on {1}.</p><p>The customer\'s reply is: <blockquote><i>"{2}"</i></blockquote></p><p>The file is available at this address: <a href="{3}">{3}</a></p>',
  'email.customer.replied.sms.notification.message.none':
    '<p>The customer has replied to SMS notification on {0}.</p><p>The customer\'s reply is: <blockquote><i>"{1}"</i></blockquote></p><p>The file is available at this address: <a href="{2}">{2}</a></p>',
  'email.customer.replied.sms.notification.title':
    '{@productName} - [{0}] - The customer has replied to SMS notification',
  'email.customer.subject': '{dealerName} - After-Sales - Notification',
  'email.customer_accepted_additional_offer.message':
    '<p>The customer has accepted the offer on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_accepted_additional_offer.message.company':
    '<p>The customer, <b>{0}</b>, has accepted the offer on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.customer_accepted_additional_offer.message.none':
    '<p>The customer has accepted the offer on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_accepted_additional_offer.title': '{@productName} - [{0}] - The customer has accepted the offer.',
  'email.customer_accepted_additional_works.message':
    '<p>The customer has accepted additional works on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_accepted_additional_works.message.company':
    '<p>The customer, <b>{0}</b>, has accepted additional works on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.customer_accepted_additional_works.message.none':
    '<p>The customer has accepted additional works on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_accepted_additional_works.title':
    '{@productName} - [{0}] - The customer has accepted additional works.',
  'email.customer_answered_chatbot.message':
    '<p>A bodywork file has been completed, the {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_answered_chatbot.message.company':
    '<p>A bodywork file has been completed by <b>{0}</b>, the {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.customer_answered_chatbot.message.neutral':
    '<p>A bodywork file has been completed by <b>{0}</b>, the {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.customer_answered_chatbot.message.none':
    '<p>A bodywork file has been completed, the {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_answered_chatbot.title':
    '{@productName} - [{0}] - A bodywork file has been completed using the Chatbot',
  'email.customer_answered_in_sales.message':
    '<p>The customer answered "{0}" on {1}.</p><p>The file is available at this address:  <a href="{2}">{2}</a>.</p>',
  'email.customer_answered_in_sales.message.company':
    '<p>The customer, <b>{0}</b>, answered "{1}" on {2}.</p><p>The file is available at this address:  <a href="{3}">{3}</a>.</p>',
  'email.customer_answered_in_sales.message.none':
    '<p>The customer answered "{0}" on {1}.</p><p>The file is available at this address:  <a href="{2}">{2}</a>.</p>',
  'email.customer_answered_in_sales.opinion.absolutely': 'Absolutely',
  'email.customer_answered_in_sales.opinion.call_me_back': "I'd like to be called back",
  'email.customer_answered_in_sales.opinion.call_me_back.failure': 'Your contact request cannot be sent.',
  'email.customer_answered_in_sales.opinion.call_me_back.success': 'Your contact request has been sent.',
  'email.customer_answered_in_sales.opinion.call_me_back.sure': 'Are you sure that you want to be called back?',
  'email.customer_answered_in_sales.opinion.no': 'No',
  'email.customer_answered_in_sales.opinion.yes': 'Yes',
  'email.customer_answered_in_sales.title': '{@productName} - [{0}] - The customer answered "{1}"',
  'email.customer_first_read.message':
    '<p>The customer has read the file on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_first_read.message.company':
    '<p>The customer, <b>{0}</b>, has read the file on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.customer_first_read.message.none':
    '<p>The customer has read the file on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_first_read.title': '{@productName} - [{0}] - The customer has read the file',
  'email.customer_info_updated.title': '{@productName} - [{0}] - The customer has updated their information',
  'email.customer_info_updated_permanently.message':
    '<p>The customer has permanently updated their information for file [{0}].</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_info_updated_temporary.message':
    '<p>The customer has temporarily updated their information for file [{0}].</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_paid_deposit_offer.message':
    '<p>The customer has paid the deposit of the offer on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_paid_deposit_offer.message.company':
    '<p>The customer, <b>{0}</b>, has paid the deposit of the offer on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.customer_paid_deposit_offer.message.none':
    '<p>The customer has paid the deposit of the offer on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_paid_deposit_offer.title': '{@productName} - [{0}] - The customer has paid the deposit of the offer',
  'email.customer_paid_deposit_works.message':
    '<p>The customer has paid the deposit of the works on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_paid_deposit_works.message.company':
    '<p>The customer, <b>{0}</b>, has paid the deposit of the works on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.customer_paid_deposit_works.message.none':
    '<p>The customer has paid the deposit of the works on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_paid_deposit_works.title': '{@productName} - [{0}] - The customer has paid the deposit of the works',
  'email.customer_paid_final_invoice.message':
    '<p>The customer, has paid the final invoice on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_paid_final_invoice.message.none':
    '<p>The customer, has paid the final invoice on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_paid_final_invoice.title': '{@productName} - [{0}] - The customer has paid the final invoice',
  'email.customer_paid_offer.message':
    '<p>The customer has paid the offer on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_paid_offer.message.company':
    '<p>The customer, <b>{0}</b>, has paid the offer on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.customer_paid_offer.message.none':
    '<p>The customer has paid the offer on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_paid_offer.title': '{@productName} - [{0}] - The customer has paid the offer',
  'email.customer_paid_works.message':
    '<p>The customer has paid the works on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_paid_works.message.company':
    '<p>The customer, <b>{0}</b>, has paid the works on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.customer_paid_works.message.none':
    '<p>The customer has paid the works on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_paid_works.title': '{@productName} - [{0}] - The customer has paid the works',
  'email.customer_refused_additional_offer.message':
    '<p>The customer has refused the offer on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_refused_additional_offer.message.company':
    '<p>The customer, <b>{0}</b>, has refused the offer on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.customer_refused_additional_offer.message.none':
    '<p>The customer has refused the offer on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_refused_additional_offer.title': '{@productName} - [{0}] - The customer has refused the offer',
  'email.customer_refused_additional_works.message':
    '<p>The customer has refused additional works on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_refused_additional_works.message.company':
    '<p>The customer, <b>{0}</b>, has refused additional works on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.customer_refused_additional_works.message.none':
    '<p>The customer has refused additional works on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.customer_refused_additional_works.title': '{@productName} - [{0}] - The customer has refused additional works',
  'email.device_created.message':
    '<p>Please find below the QR code to connect the device to the dealership.<br>You can scan it once and once only from the {appName} mobile application.</p><br><div align=\'center\'><img src="{qrCodeUrl}" width="300" height="300" alt=""/></div>',
  'email.device_created.subject': 'New device',
  'email.device_created.title': 'The device {deviceName} has been added to {dealerName}',
  'email.final_invoice': 'Please find below the final invoice to be paid for your appointment at {0}',
  'email.final_invoice.info': 'Please find below the final invoice for your appointment at {0}',
  'email.footer.confidentiality.policy':
    '<p>Please remember that by placing your order, you have declared your consent to the GTC and the <a href="{link}">data handling policy</a>.<br />You have expressly agreed to the execution of the contract before the end of the withdrawal period. You have been informed that the right of withdrawal expires at the start of contract execution.</p>',
  'email.footer.contact.us': 'If you have any questions, please feel free to contact us.',
  'email.footer.general.terms.conditions':
    '<p>You can find our General Terms and Conditions <a href="{link}">here</a>.<br />We recommend that you download our General Terms and Conditions immediately after reading this, so that you are always aware of the terms and conditions that apply to your current order.</p>',
  'email.footer.legal.notice': '<a href="{link}">Legal notice policy</a>.',
  'email.for.team.after': '\\ team,',
  'email.for.team.before': 'For the',
  'email.from': 'Email from',
  'email.have.nice.day': '',
  'email.internal.subject': '{@productName} - Notification',
  'email.intervention.concatenated.body': 'The generation of your video for file {0} is finished.',
  'email.intervention.concatenated.button': 'Click here to download it.',
  'email.intervention.concatenated.title': 'Your video is ready !',
  'email.intervention_assigned.message': 'You have been assigned to the file {0}: <a href="{1}">{1}</a>.',
  'email.intervention_assigned.title': '{@productName} - [{0}] - You have been assigned to a file',
  'email.intervention_bad_rated.message':
    '<p>The customer, gave a rating less than or equal to 3 on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.intervention_bad_rated.message.none':
    '<p>The customer, gave a rating less than or equal to 3 on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.intervention_bad_rated.title': '{@productName} - [{0}] - A customer gave a bad rating',
  'email.intervention_comment_added.customer': 'the customer',
  'email.intervention_comment_added.message':
    'A new comment has been added by the customer on {0} in the following file: {1}',
  'email.intervention_comment_added.message.none':
    'A new comment has been added by the customer on {0} in the following file: {1}',
  'email.intervention_comment_added.title': '{@productName} - [{0}] - New comment added',
  'email.intervention_completed_by_technician.message':
    '<p>A file has been completed by {0} on {1} and is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.intervention_completed_by_technician.title': '{@productName} - [{0}] - A file is available',
  'email.intervention_completed_by_technician.title.attention': '[Attention]',
  'email.intervention_duplicated.message':
    'The file {0} has been duplicated by {1} on {2} and is available at this address: <a href="{3}">{3}</a>',
  'email.intervention_duplicated.title': '{@productName} - [{0}] - File duplicated',
  'email.intervention_email_send_issue.message':
    '<p>The file sent at {0} contains a valid email but could not be delivered to the customer by email. Please verify the <a href="{1}">file</a>.</p>',
  'email.intervention_email_send_issue.title': '{@productName} - [{0}] - File with a non delivered email',
  'email.intervention_invalid_email.message':
    '<p>The file sent at {0} contains an invalid email. Please verify the <a href="{1}">file</a>.</p>',
  'email.intervention_invalid_email.title': '{@productName} - [{0}] - File with an invalid email',
  'email.intervention_reopen.message':
    'The file {0} has been unarchived by {1} on {2} and is available at this address: <a href="{3}">{3}</a>',
  'email.intervention_reopen.title': 'File unarchived',
  'email.interventionStatistics.export.body':
    'The statistics export of the files {0} from <b>{1}</b> to <b>{2}</b> for <b>{3}</b> is available.',
  'email.interventionStatistics.export.body.brand-manager':
    'The statistics export of the files {0} from <b>{1}</b> to <b>{2}</b> is available.',
  'email.interventionStatistics.export.created': 'created',
  'email.interventionStatistics.export.group': '{0} group',
  'email.interventionStatistics.export.groups': 'all your groups',
  'email.interventionStatistics.export.planned': 'planned',
  'email.interventionStatistics.export.sent': 'sent',
  'email.interventionStatistics.export.sentIntervention': 'It only uses <b>sent files</b>.',
  'email.interventionStatistics.export.subject': '{@productName} - Statistics export',
  'email.interventionStatistics.export.title': 'Your after-sales statistics export is here !',
  'email.key_deposit.added_billing_work': 'The {0} team has added works to be paid for your appointment:',
  'email.key_deposit.added_rental_document': 'The {0} team has added documents to be signed for your appointment:',
  'email.key_deposit.added_repair_order_work': 'The {0} team has added works for your appointment:',
  'email.key_deposit.customer_keys_retrieved': 'The {0} team has retrieved your key:',
  'email.key_deposit.default': 'Here is the follow-up of your vehicle by the {0} team:',
  'email.key_deposit.issue_identified': 'The {0} team identified a problem with your appointment:',
  'email.key_deposit.locker_ready': 'The safe for your appointment at {0} is ready:',
  'email.key_deposit.message_received': 'The {0} team sent you a message for your appointment:',
  'email.key_deposit.rental_keys_retrieved': 'The {0} team has retrieved the rental key:',
  'email.key_deposit.waiting_client_document': 'The {0} team needs documents for your appointment:',
  'email.kiosk.emergency_mode_alert.title': 'Alert',
  'email.kiosk.offline_alert.message':
    '<p>The kiosk <b>{kioskName}</b> is currently offline.</p><p>The kiosk is currently <b>unavailable to customers</b>, please make sure that it is <b>plugged in</b> & <b>connected to the internet</b>.</p>',
  'email.kiosk.online_alert.message':
    '<p>The kiosk <b>{kioskName}</b> is currently online & <b>available to customers</b></p>',
  'email.kiosk.online_alert.title': 'Information',
  'email.kiosk.partteam.emergency_mode_alert.message':
    '<p>There is currently a problem on the kiosk: <b>{kioskName}</b></p><p>The kiosk is currently <b>unavailable to customers</b> due to an incident following a check-in/check-out, please go to the kiosk & <b>follow the instructions to resolve the issues.</b></p><p>To complete the procedure safely, you must have the <b>"kiosk emergency access"</b> permission and the <b>kiosk keys.</b></p>',
  'email.kiosk.sharebox.emergency_mode_alert.message':
    '<p>There is currently a problem on the kiosk: <b>{kioskName}</b></p><p>The kiosk is currently <b>unavailable</b> due to an incident. Please verify that everything is functioning and contact support line +32 2 80 80 828 in case an issue persists.</p>',
  'email.lead_added.message':
    '<p>A customer filled out the contact form on {0}.</p><p>The lead is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.lead_added.title': '[{0}] - A customer filled out the contact form.',
  'email.link': 'Take me to my vehicle check',
  'email.link.appointment': 'Take me to my appointment',
  'email.link.messenger': 'Facebook Messenger',
  'email.link.webchat': 'Webchat',
  'email.main':
    'Following your visit in our workshop, please find additional information by selecting the following link:',
  'email.main.bilia_jagersro_dackcenter': '',
  'email.main.new.lead.message':
    'You have requested to be recontacted by {0} concerning a stock file. <br> If you think this is an error, you can unsubscribe <a href="{1}">here</a>.',
  'email.manual_acceptation.accepted.message':
    '<p><b>{0}</b> manually accepted tasks on behalf of the customer on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.manual_acceptation.accepted.message.none':
    '<p><b>{0}</b> manually accepted tasks on behalf of the customer on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.manual_acceptation.accepted.title': '{@productName} - [{0}] - The tasks have been manually approved.',
  'email.manual_acceptation.refused.message':
    '<p><b>{0}</b> manually rejected tasks on behalf of the customer on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.manual_acceptation.refused.message.none':
    '<p><b>{0}</b> manually rejected tasks on behalf of the customer on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.manual_acceptation.refused.title': '{@productName} - [{0}] - The tasks have been manually rejected.',
  'email.mfa.code.prefix': 'Your verification code is:',
  'email.mfa.code.suffix': 'This code will expire {expiration} minutes after receiving of this email.',
  'email.mfa.footer': "If you haven't tried logging into Fleetback, please consider changing your password.",
  'email.mfa.subject': '{@productName} - Your authentication code',
  'email.mfa.title': 'Verification code',
  'email.mobility_document_media_added.message':
    '<p>The customer has uploaded the requested documents for mobility on {0} on the file {1}: <a href="{2}">{2}</a>.</p>',
  'email.mobility_document_media_added.title': '{@productName} - [{0}] - Customer documents to validate',
  'email.mobility_refused.message':
    '<p>The customer no longer wishes a courtesy vehicle as of {0}. The file is available at this address: <a href={1}>{1}</a>.</p>',
  'email.mobility_refused.message.none':
    '<p>The customer no longer wishes a courtesy vehicle as of {0}. The file is available at this address: <a href={1}>{1}</a>.</p>',
  'email.mobility_refused.title': '{@productName} - [{0}] - The customer no longer wishes a courtesy vehicle',
  'email.notification.arhs':
    '{@productName} is a company specialized in the development of digital solution and tailor-made projects for the automotive industry.',
  'email.notification.copyright': '<em>&copy; 2017-{0}&nbsp;</em>{@productName}<em>, All rights reserved.</em>',
  'email.notification.no_reply':
    "Attention, this message has been automatically generated. Do not use the 'Reply' function nor use this sender's e-mail address.",
  'email.notification.settings': 'Click <a href="{0}">here</a> to change your notification settings',
  'email.notification.unsubscribe':
    'If you want to update your statistic email settings, <a href="{0}">click here</a>. To edit your KPI, head to the Statistics tab in your configuration.',
  'email.notification.update':
    'We would like to inform you of new updates regarding your vehicle. You can find more information by clicking on the following link:',
  'email.notification.website.title': 'Our website',
  'email.offer.export.body': '<p>The offers export from the last 12 months is available.</p>',
  'email.offer.export.title': 'Your offers export is here !',
  'email.password_reset.button': 'Reset password',
  'email.password_reset.message':
    'We received a request to reset your Fleetback password. Please click the following link to reset your password:',
  'email.password_reset.subject': 'Fleetback - Request to reset your password',
  'email.password_reset.title': 'Request to reset your password',
  'email.password_reset.warning':
    'The reset link will only be valid for {duration} hour. If your link is no longer valid or if something is not working, you can request a new reset link at <a href="{url}" style="-webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%; font-weight: 600; color: #003763 !important;">{url}</a>.',
  'email.payments.export.body': 'The export of payments from <b>{0}</b> to <b>{1}</b> for <b>{2}</b> is available.',
  'email.payments.export.body.brand-manager': 'The export of payments from <b>{0}</b> to <b>{1}</b> is available.',
  'email.payments.export.title': 'Your payment export is here !',
  'email.personal.key_deposit.customer_keys_retrieved': '{0} {1}, the {2} team has retrieved your key:',
  'email.personal.key_deposit.default': '{0} {1}, here is the follow-up of your vehicle by the {2} team:',
  'email.personal.key_deposit.issue_identified': '{0} {1}, the {2} team identified a problem with your appointment:',
  'email.personal.key_deposit.locker_ready': '{0} {1}, the safe for your appointment at {2} is ready:',
  'email.personal.key_deposit.message_received': '{0} {1}, the {2} team sent you a message for your appointment:',
  'email.personal.key_deposit.rental_keys_retrieved': '{0} {1}, the {2} team has retrieved the rental key:',
  'email.proview_first_read.message':
    '<p>The file has been read for professional purposes on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.proview_first_read.message.company':
    '<p>The file has been read for professional purposes on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.proview_first_read.message.none':
    '<p>The file has been read for professional purposes on {0}.</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.proview_first_read.title': '{@productName} - [{0}] - The file has been read for professional purposes',
  'email.questionFormStatistics.export.body':
    '<p>The statistics export for the question template <b>{1}</b>, from <b>{2}</b> to <b>{3}</b>, for <b>{0}</b> is available.</p>',
  'email.questionFormStatistics.export.title': 'Your statistics export is here !',
  'email.self_service.answered.message':
    '<p>The customer has completed the {0} on {1}.</p><p>The file is available at this address: <a href="{2}">{2}</a>.</p>',
  'email.self_service.answered.title': '{@productName} - [{0}] - {1} completed',
  'email.self_service.breakdown_created.kiosk.message':
    '<p>A breakdown file has been created from the kiosk on {date} and is available at this address: <a href="{link}">{link}</a>.</p>',
  'email.self_service.breakdown_created.on_site.message':
    '<p>A breakdown file has been created from a mobile on {date} and is available at this address: <a href="{link}">{link}</a>.</p>',
  'email.self_service.breakdown_created.title': 'A breakdown file is available',
  'email.self_service.comment_added.message':
    '<p>The customer left a comment or a media in their check-in on {0}. The file is available at this address: <a href={1}>{1}</a>.</p>',
  'email.self_service.comment_added.message.none':
    '<p>The customer left a comment or a media in their check-in on {0}. The file is available at this address: <a href={1}>{1}</a>.</p>',
  'email.self_service.comment_added.title':
    '{@productName} - [{0}] - The customer left a comment or a media in their check-in',
  'email.self_service.extras_accepted.message':
    '<p>The customer has accepted extras in their check-in on {0}. The file is available at this address: <a href={1}>{1}</a>.</p>',
  'email.self_service.extras_accepted.message.none':
    '<p>The customer has accepted extras in their check-in on {0}. The file is available at this address: <a href={1}>{1}</a>.</p>',
  'email.self_service.extras_accepted.title': '{@productName} - [{0}] - The customer has accepted extras',
  'email.self_service.question_answered.message':
    '<p>The customer has answered questions on {1}.</p><p>{2}</p><p><b>Contact info</b><br>{3}</p><p><b>Vehicle</b><br>{4}</p><p>The file is available at this address: <a href="{5}">{5}</a>.</p>',
  'email.self_service.question_answered.message.none':
    '<p>The customer has answered questions on {1}.</p><p>{2}</p><p><b>Contact info</b><br>{3}</p><p><b>Vehicle</b><br>{4}</p><p>The file is available at this address: <a href="{5}">{5}</a>.</p>',
  'email.self_service.question_answered.subject': '{@productName} - [{0}] - The customer answered a question',
  'email.self_service.question_answered.title': '<p>Fleetback - {0} - The customer has answered questions</p>',
  'email.self_service.slot_emptied.message':
    '<p>The customer has dropped the mobility keys of {0} file</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.self_service.slot_emptied.title': '{@productName} - The customer has dropped mobility keys in the kiosk',
  'email.self_service.slot_filled.message':
    '<p>The customer has dropped the keys of {0} file</p><p>The file is available at this address: <a href="{1}">{1}</a>.</p>',
  'email.self_service.slot_filled.title': '{@productName} - The customer has dropped keys in the kiosk',
  'email.selfChecklistAdviceStatistics.export.body':
    'The statistics export of the self service checklist advices {0} from <b>{1}</b> to <b>{2}</b> for <b>{3}</b> is available.',
  'email.selfChecklistAdviceStatistics.export.body.brand-manager':
    'The statistics export of the self service checklist advices {0} from <b>{1}</b> to <b>{2}</b> is available.',
  'email.selfChecklistAdviceStatistics.export.created': 'created',
  'email.selfChecklistAdviceStatistics.export.group': '{0} group',
  'email.selfChecklistAdviceStatistics.export.groups': 'all your groups',
  'email.selfChecklistAdviceStatistics.export.planned': 'planned',
  'email.selfChecklistAdviceStatistics.export.sent': 'sent',
  'email.selfChecklistAdviceStatistics.export.subject': '{@productName} - Statistics export',
  'email.selfChecklistAdviceStatistics.export.title': 'Your statistics export is here !',
  'email.statistics.download': 'Download',
  'email.statistics.export.brand': 'Brand exported:',
  'email.statistics.export.brands': 'Brands exported:',
  'email.statistics.export.countries': 'Countries exported:',
  'email.statistics.export.country': 'Country exported:',
  'email.statistics.export.module': 'Module exported:',
  'email.statistics.export.modules': 'Modules exported:',
  'email.statistics.export.type': 'Type of export:',
  'email.statistics.export.type.bo': 'Aggregated file',
  'email.statistics.export.type.raw': 'Raw file',
  'email.statistics.failedExport.body':
    'An error occurred during the export of your statistics. Please try again later.',
  'email.statistics.failedExport.footer':
    '<p>Error code: <b>{0}</b><br>Please provide this error code to Fleetback support for help.</p>',
  'email.statistics.failedExport.title': 'Error',
  'email.statistics.summary.subject': '{@productName} - {0} Weekly Summary',
  'email.step_update.body': 'The team {0} informs you that your vehicle is at step: {1}.',
  'email.step_update.message':
    'The file {0} was moved to step {1} by {2} on {3} and is available at this address: <a href="{4}">{4}</a>',
  'email.step_update.ready.body': 'The {0} team would like to inform you that your vehicle is now ready for pickup.',
  'email.step_update.title': 'Step update',
  'email.subject': '{@productName} - After-Sales - Notification',
  'email.subject.mfa.code': 'Your authentication code',
  'email.subject.new.lead': 'Contact form submitted',
  'email.summary-stats.button.title': 'Access statistics',
  'email.summary-stats.decrease': 'drop',
  'email.summary-stats.details.days': 'day(s)',
  'email.summary-stats.details.group': 'Group',
  'email.summary-stats.details.myDealerships': 'My dealerships',
  'email.summary-stats.details.week': 'Week',
  'email.summary-stats.increase': 'rise',
  'email.summary-stats.intervention': 'file',
  'email.summary-stats.interventions': 'files',
  'email.summary-stats.legend.myDealerships': 'Dealerships in which you are a manager',
  'email.summary-stats.less': 'fewer',
  'email.summary-stats.more': 'more',
  'email.summary-stats.other': 'Other',
  'email.summary-stats.resume.acceptationratio':
    'Your conversion rate is <strong>{0}{1}%</strong>, a {3}% {2} compared to last week ({4}%).',
  'email.summary-stats.resume.acceptationratio.equal':
    'Your conversion rate is <strong>{0}{1}%</strong>, which is the same as last week.',
  'email.summary-stats.resume.accepted':
    'The total amount accepted is <strong>{0}{1}</strong>, which is {2} {3} compared to last week ({4}).',
  'email.summary-stats.resume.accepted.equal':
    'The total amount accepted is <strong>{0}{1}</strong>, which is the same amount as last week.',
  'email.summary-stats.resume.after-sales.contributors.contributor': 'In after-sales, the best contributor is:',
  'email.summary-stats.resume.after-sales.contributors.contributors': 'In after-sales, the best contributors are:',
  'email.summary-stats.resume.after-sales.contributors.top': 'For the after-sales, the top',
  'email.summary-stats.resume.amountratio':
    'Your revenue rate is <strong>{0}{1}%</strong>, a {3}% {2} compared to last week ({4}%).',
  'email.summary-stats.resume.amountratio.equal':
    'Your revenue rate is <strong>{0}{1}%</strong>, which is the same as last week.',
  'email.summary-stats.resume.details': 'By dealership',
  'email.summary-stats.resume.details.additional-works.accepted.amount': 'Accepted amount',
  'email.summary-stats.resume.details.additional-works.proposed.amount': 'Proposed amount',
  'email.summary-stats.resume.details.contributors.top-after-sales': 'Top after-sales',
  'email.summary-stats.resume.details.contributors.top-sales': 'Top sales',
  'email.summary-stats.resume.details.legend.dealer-manager.before':
    'In addition to your teams, dealerships sharing their statistics are displayed with this symbol',
  'email.summary-stats.resume.details.legend.difference': 'difference compared to the previous week',
  'email.summary-stats.resume.details.total': 'Total',
  'email.summary-stats.resume.general': 'Overview',
  'email.summary-stats.resume.intervention':
    'Your team created a total of <strong>{0}{1} {2}</strong> this week, which is <strong> {3} </strong> {4} than last week ({5}).',
  'email.summary-stats.resume.intervention.equal':
    'Your team created a total of <strong>{0}{1} {2}</strong> this week, which is the same as last week.',
  'email.summary-stats.resume.intervention.plural':
    'Your teams have created a total of <strong>{0}{1} {2}</strong> this week, which is  {3}  {4} than last week ({5}).',
  'email.summary-stats.resume.intervention.plural.equal':
    'Your teams have created a total of <strong>{0}{1} {2}</strong> this week, which is the same as last week.',
  'email.summary-stats.resume.proposed':
    'The total amount offered is <strong>{0}{1}</strong>, which is {2} {3} compared to last week ({4}).',
  'email.summary-stats.resume.proposed.equal':
    'The total amount offered is <strong>{0}{1}</strong>, which is the same amount as last week.',
  'email.summary-stats.resume.sales.contributors.contributor': 'In sales, the best contributor is:',
  'email.summary-stats.resume.sales.contributors.contributors': 'In sales, the best contributors are:',
  'email.summary-stats.subtitle':
    'Here is a summary of your dealerships\' Fleetback use this week. For more information, you can view the statistics via the "Statistics"> "After-sales / Sales" menu of the web application.',
  'email.summary-stats.table.columns.accepted': 'Accepted amount',
  'email.summary-stats.table.columns.created': 'Created',
  'email.summary-stats.table.columns.dealership': 'Dealership',
  'email.summary-stats.table.columns.kpi': 'KPI',
  'email.summary-stats.table.columns.latestIntervention': 'Latest file',
  'email.summary-stats.table.columns.monthlyTotal': 'Total for current month',
  'email.summary-stats.table.columns.planned': 'Planned',
  'email.summary-stats.table.columns.quotes': 'Sent with quote',
  'email.summary-stats.table.columns.read': 'Opened',
  'email.summary-stats.table.columns.sendRate': 'Sending rate',
  'email.summary-stats.table.columns.sent': 'Sent',
  'email.summary-stats.table.columns.sentWithVideo': 'Sent with video',
  'email.summary-stats.table.subtitle':
    'Find underneath the file statistics (excluding warranty) of all the dealerships that share them.',
  'email.summary-stats.table.title': 'After-sales statistics',
  'email.summary-stats.title': 'Weekly summary for {0}',
  'email.summary-stats.title.monthly': 'Monthly summary for {0}',
  'email.summary-stats.title.weekly': 'Weekly summary for {0}',
  'email.title': 'Information about your {1} {2}',
  'email.title.key_deposit': 'Follow-up of your appointment',
  'email.title.new.lead.title': 'Contact form submitted',
  'email.van.avondt.bmw.please.find.complementary.information':
    'At BMW JUMA Louvain we believe in the excellence of our customer service. To keep you informed, we made a personalized video presentation of the vehicle you are interested in.',
  'email.van.avondt.mini.please.find.complementary.information':
    'Your new MINI will be delivered soon. At MINI JUMA in Leuven we believe in outstanding customer service, and we try to exceed our customers’ expectations. So today we are  sending you a sneak preview of your new car. We wish you much driving pleasure!',
  'email.van.avondt.take.me.to.complementary.info': 'Take me to the video presentation',
  'email.van.avondt.thanks.interest': 'Thanks for your interest.',
  'events.accepted': 'Accepted',
  'events.accepted_policy_confidentiality_policy': 'Data handling policy accepted',
  'events.accepted_policy_general_terms_condition': 'General terms and conditions accepted',
  'events.answered': 'Answered',
  'events.create': 'Created',
  'events.details.email': 'from email',
  'events.details.link': 'from direct link',
  'events.details.manually': 'manually',
  'events.details.sms': 'from SMS',
  'events.details.whatsapp': 'from WhatsApp',
  'events.drop_off_confirmed': 'Drop-off confirmed',
  'events.drop_off_locker_code_generated': 'Drop-off safe code generated',
  'events.pick_up_confirmed': 'Pick-up confirmed',
  'events.pick_up_locker_code_generated': 'Pick-off safe code generated',
  'events.read': 'Read',
  'events.rejected': 'Rejected',
  'events.rental_documents_signed': 'Rental document(s) signed',
  'events.repair_order_answered': 'Repair order answered',
  'events.self_service_answered_home_check_in': 'Home check-in completed',
  'events.self_service_answered_home_check_out': 'Home check-out completed',
  'events.self_service_answered_kiosk_check_in': 'Kiosk check-in completed',
  'events.self_service_answered_kiosk_check_out': 'Kiosk check-out completed',
  'events.self_service_answered_on_site_check_in': 'On-site check-in completed',
  'events.self_service_answered_on_site_check_out': 'On-site check-out completed',
  'events.self_service_breakdown_created_kiosk_breakdown': 'Breakdown created',
  'events.self_service_breakdown_created_on_site_breakdown': 'Breakdown created',
  'events.self_service_sent_home_check_in': 'Check-in sent',
  'events.self_service_sent_home_check_out': 'Check-out sent',
  'events.sent': 'Sent',
  'fuels.CNG': 'GNC',
  'fuels.DIESEL': 'Diesel',
  'fuels.ELECTRIC': 'Électrique',
  'fuels.HYBRID': 'Hybride',
  'fuels.LPG': 'L.P.G.',
  'fuels.PETROL': 'Essence',
  'intervention.already_closed': 'The file is already archived.',
  'intervention.already_sent': 'The file has been already sent.',
  'intervention.breakdown_service.reference': 'Unplanned - {registration}',
  'intervention.has_invalid_phone_number': 'The file has an invalid phone number.',
  'intervention.id_not_found': 'The file with the identifier: {0} could not be found.',
  'intervention.message_only': 'You may chat with your technician here.',
  'intervention.message_only.MY_BMW_APP': 'Chat is now available and allows you to get in touch with your dealership.',
  'intervention.no_email': 'No e-mail address is defined.',
  'intervention.no_phone_number': 'No phone number is defined.',
  'intervention.noappointmentlink': 'The file has no appointment link.',
  'intervention.readonly': 'The file is read-only.',
  'networks.established': 'Internet connection recovered',
  'networks.lost': 'Connection internet lost',
  'notification.appointment_answered.message': 'Appointment {reference} has been answered',
  'notification.appointment_created.message': 'Appointment {reference} has been created',
  'notification.appointment_document_accepted.message': 'Appointment {reference} documents have been accepted',
  'notification.appointment_document_updated.message': 'Appointment {reference} documents have been updated',
  'notification.appointment_issue_reported.message': 'An issue has been reported on appointment {reference}',
  'notification.appointment_paid.message': 'Appointment {reference} has been paid',
  'notification.appointment_rental_signed.message': 'Appointment {reference} rental documents have been signed',
  'notification.appointment_reopened.message': 'Appointment {reference} has been unarchived',
  'notification.appointment_vault_updated.message': 'Appointment {reference} locker has been updated',
  'notification.audit_completed.message': 'Audit {reference} was completed by {userName}',
  'notification.audit_created.message': 'Audit {reference} was created by {userName}',
  'notification.audit_duplicated.message': 'Audit {reference} was duplicated by {userName}',
  'notification.audit_kpi_answered.message': 'An answer to a KPI question was added to audit {reference} by {userName}',
  'notification.audit_reopened.message': 'Audit {reference} was unarchived by {userName}',
  'notification.campaign_unsubscribe.message': 'A customer from the {contactListName} contact list has unsubscribed.',
  'notification.conversation_created.message': 'A new conversation was created',
  'notification.conversation_message_created.appointment.message':
    'You have a new message about appointment {reference}',
  'notification.conversation_message_created.chat.message': 'You have a new message',
  'notification.conversation_message_created.customer.message':
    'The customer has sent a message in the {reference} file',
  'notification.conversation_message_created.message': 'An internal message is available in the file {reference}',
  'notification.intervention_accepted.message': 'The {reference} file has been answered',
  'notification.intervention_answered.message': 'The customer wants to be contacted concerning the {reference} file',
  'notification.intervention_assigned.message': 'You have been assigned to {reference} file',
  'notification.intervention_bad_rated.message': 'The customer gave a bad rating about file {reference}',
  'notification.intervention_created.message': 'The {reference} file has been created',
  'notification.intervention_customer_info_updated.permanently.message':
    'The customer has permanently updated their information for file {reference}',
  'notification.intervention_customer_info_updated.temporary.message':
    'The customer has temporarily updated their information for file {reference}',
  'notification.intervention_deposit.message': 'The customer has paid the deposit on {reference} file',
  'notification.intervention_duplicated.message': 'The {reference} file has been duplicated',
  'notification.intervention_lead_created.message': 'A new lead was added for the file {reference}',
  'notification.intervention_mobility_document_media_added.message':
    'Customer documents to validate in file {reference}',
  'notification.intervention_mobility_refused.message':
    'The customer no longer wishes a courtesy vehicle on {reference} file',
  'notification.intervention_payment.final_invoice.message': 'The customer has paid the invoice of file {reference}',
  'notification.intervention_payment.message': 'The customer has paid the {reference} file',
  'notification.intervention_read.message': 'The {reference} file has been read',
  'notification.intervention_rejected.message': 'The {reference} file has been refused',
  'notification.intervention_reopened.message': 'The {reference} file has been unarchived',
  'notification.intervention_self_service_answered.message': 'The customer completed the {type} for file {reference}',
  'notification.intervention_self_service_breakdown_created.message': 'The unplanned file {reference} has been created',
  'notification.intervention_self_service_comment_added.message':
    'The customer left a comment or a media in their check-in in file {reference}',
  'notification.intervention_self_service_extras_accepted.message':
    'The customer has accepted extras in their check-in in file {reference}',
  'notification.intervention_self_service_question_answered.message':
    'The customer has answered a question you are following in file {reference}',
  'notification.intervention_self_service_slot_emptied.message':
    'The customer has dropped the mobility keys of {reference} file',
  'notification.intervention_self_service_slot_filled.message': 'The customer has dropped the keys of {reference} file',
  'notification.intervention_step.message': 'The {reference} file has reached step {stepName}',
  'og.description': 'Contact us for further information or vehicle test',
  'og.description.or': 'or',
  'og.description.phone.number': 'at {0}',
  'og.description.via.fleetback': '- via Fleetback',
  or: 'or',
  'page.fiche.medias.360.helper': 'Click and drag to move around in the panorama',
  'payment.fo.bezahl.redirect.button': 'Go back to my file',
  'predefined_message.title': 'Default message',
  reference: 'Référence',
  'self_service.home_check_in': 'Home check-in',
  'self_service.home_check_out': 'Home check-out',
  'self_service.kiosk_check_in': 'Kiosk check-in',
  'self_service.kiosk_check_out': 'Kiosk check-out',
  'self_service.on_site_check_in': 'On-site check-in',
  'self_service.on_site_check_out': 'On-site check-out',
  'sender.parse_email_body': "An error occurred while parsing the email's body.",
  'severity.high.image-path': 'public/common/app/images/icons/severity_high.svg',
  'severity.low.image-path': 'public/common/app/images/icons/severity_low.svg',
  'severity.none.image-path': 'public/common/app/images/icons/severity_none.svg',
  'sms.body': '{greeting}, here is the follow-up of your vehicle by the {0} team: {1}',
  'sms.body.automatic_resend': '{greeting}, here is a reminder to consult the follow-up of your vehicle: {1}',
  'sms.body.browser': 'Via web browser {0}',
  'sms.body.chat.message': '{greeting}, the {dealer} team sent you a new message: {link}',
  'sms.body.final_invoice': '{greeting}, please find the final invoice to be paid for your appointment at {0}: {1}',
  'sms.body.final_invoice.info': '{greeting}, please find the final invoice for your appointment at {0}: {1}',
  'sms.body.key_deposit.added_billing_work':
    '{greeting}, the {0} team has added works to be paid for your appointment: {1}',
  'sms.body.key_deposit.added_rental_document':
    '{greeting}, the {0} team has added documents to be signed for your appointment: {1}',
  'sms.body.key_deposit.added_repair_order_work': '{greeting}, the {0} team has added works for your appointment: {1}',
  'sms.body.key_deposit.customer_keys_retrieved': '{greeting}, the {0} team has retrieved your key: {1}',
  'sms.body.key_deposit.issue_identified': '{greeting}, the {0} team identified a problem with your appointment: {1}',
  'sms.body.key_deposit.locker_ready': '{greeting}, the safe for your appointment at {0} is ready: {1}',
  'sms.body.key_deposit.message_received': '{greeting}, the {0} team send you a message for your appointment: {1}',
  'sms.body.key_deposit.rental_keys_retrieved': '{greeting}, the {0} team has retrieved the rental key: {1}',
  'sms.body.key_deposit.waiting_client_document': '{greeting}, the {0} team needs documents for your appointment: {1}',
  'sms.body.manually.acceptation':
    '{greeting}, here is your decision report concerning additional works by the {0} team: {1}',
  'sms.body.messenger': 'Via Messenger {0}',
  'sms.body.mfa.code': 'Here is your authentication code: {code}',
  'sms.body.notification.update': '{greeting}, you have updates regarding your vehicle from the {0} team: {1}',
  'sms.body.so.check_in':
    '{greeting}, prepare for your appointment on {date} at {time} at {dealer} by completing your check-in: {link}',
  'sms.body.so.check_in.mobility':
    '{greeting}, necessary information for your appointment with mobility solution on {date} at {time} at {dealer} requested here: {link}',
  'sms.body.so.check_in.mobility_retry': '{greeting}, Additional information is required for your check-in: {link}',
  'sms.body.so.check_in.sharebox':
    '{greeting}, for your appointment on {date} at {time} at {dealer}, use this link at home AND at the dealership: {link}',
  'sms.body.so.check_in.vehicle_check': '{greeting}, here is the link to your vehicle check: {0}',
  'sms.body.so.check_out': '{greeting}, here is the check-out of your vehicle by the {0} Team: {1}',
  'sms.body.so.check_out.final_invoice.payment_url': '{greeting}, here is the link to your payment: {url}',
  'sms.body.so.check_out.key':
    'The {dealer} team informs you that you can now come and do your check-out at the dealership at the kiosk {kiosk} and consult it right away here: {link}',
  'sms.body.so.check_out.key_kiosk_only':
    'The {dealer} team informs you that you can now come and do your check-out at the dealership at the kiosk {kiosk}',
  'sms.body.step_selected': '{greeting}, the {0} team informs you that your vehicle is at step: {1}',
  'sms.body.step_trigger.planned':
    '{greeting}, We hereby confirm your service appointment on {date} at {time}. We look forward to seeing you. Your {dealer}.',
  'sms.body.step_trigger.ready':
    '{greeting}, the {0} team would like to inform you that your vehicle is now ready for pickup.',
  'sms.body.step_trigger.reminded':
    '{greeting}, We kindly remind you of your appointment on {date} at {time} at {dealer}.',
  'sms.body.with.time': 'Please validate the works to carry out before {0} on the {1}.',
  'sms.greeting': 'Dear customer',
  'sms.greeting.personal': '{0} {1}',
  'so.email.breakdown.confirm.main':
    'Thank you for completing information about the breakdown file! You can download a summary of the information provided below.',
  'so.email.breakdown.subject': 'Breakdown file from {startDate} at {dealerName}',
  'so.email.check_in.mobility.main':
    'You have requested a mobility solution for your appointment at {dealerName}, please fill in the necessary information here:',
  'so.email.check_out.key.main':
    'The {dealerName} team informs you that you can now come and do your check-out at the dealership at the kiosk {kiosk} and consult it right away here:',
  'so.email.check_out.key_kiosk_only.main':
    'The {dealerName} team informs you that you can now come and do your check-out at the dealership at the kiosk {kiosk}',
  'so.email.check_out.link': 'Start my check-out',
  'so.email.check_out.main': 'Save time at the reception of your {brand} by completing the following check-out:',
  'so.email.check_out.subject': 'Your check-out at {dealerName}',
  'so.email.confirm.link': 'Download summary (PDF)',
  'so.email.confirm.link.sharebox': 'Finalize check-in at the dealership',
  'so.email.confirm.main':
    'Thank you for completing your {originType}! You can download a summary of the information filled in below.',
  'so.email.confirm.main.check_in': 'At the dealership, use the kiosk to finalize your {originType}.',
  'so.email.confirm.subject.check_in': 'Next step for your appointment on {startDate} at {dealerName}',
  'so.email.link': 'Start my check-in',
  'so.email.link.follow_up': 'More information',
  'so.email.link.mobility_contract': 'Mobility contract',
  'so.email.main': 'Prepare for the upcoming appointment of your {brand} by completing the following check-in:',
  'so.email.parking.name': 'Parking:',
  'so.email.parking.spot_number': 'Spot number:',
  'so.email.parking.title': 'Where to find it',
  'so.email.subject': 'Your appointment on {startDate} at {time} at {dealerName}',
  'so.email.vehicle.color': 'Color:',
  'so.email.vehicle.description': 'Model:',
  'so.email.vehicle.fuelLevel': 'Fuel level:',
  'so.email.vehicle.fuelLevel.full': '<b>Full</b>',
  'so.email.vehicle.fuelLevel.half': '<b>Half</b>',
  'so.email.vehicle.fuelLevel.one_quarter': '<b>One quarter</b>',
  'so.email.vehicle.fuelLevel.reserve': 'Reserve',
  'so.email.vehicle.fuelLevel.three_quarters': '<b>Three quarters</b>',
  'so.email.vehicle.mileage': 'Mileage:',
  'so.email.vehicle.registration': 'License plate:',
  'so.email.vehicle.subtitle': 'Find below the information about <b>your courtesy vehicle.</b>',
  'steps.defaults.follow_up.message.sms':
    'The {dealer} team thanks you for your trust and sends you this follow-up message about your appointment: {link}',
  'steps.defaults.follow_up.name': 'Follow-up',
  'steps.defaults.soft_nrg.planned.description': 'Planned',
  'steps.defaults.soft_nrg.planned.message':
    '{greeting}, We hereby confirm your appointment on {date} at {time}. We look forward to seeing you. Your {dealer}.',
  'steps.defaults.soft_nrg.ready.description': 'Ready',
  'steps.defaults.soft_nrg.ready.message':
    '{greeting}, the {dealer} team would like to inform you that your vehicle is now ready for pickup.',
  'steps.defaults.soft_nrg.reminded.description': 'Reminded',
  'steps.defaults.soft_nrg.reminded.message':
    '{greeting}, We kindly remind you of your appointment on {date} at {time} at {dealer}.',
  'tire.condition.GOOD': 'Good condition',
  'tire.condition.RECOMMENDED': 'Recommended replacement',
  'tire.condition.URGENT': 'Urgent replacement',
  'tire.generate.ALL': 'Complete set (4 tires)',
  'tire.generate.FRONT': 'Front axle (2 tires)',
  'tire.generate.REAR': 'Back axle (2 tires)',
  'tire.position.FRONT_LEFT': 'Front left',
  'tire.position.FRONT_RIGHT': 'Front right',
  'tire.position.REAR_LEFT': 'Rear left',
  'tire.position.REAR_RIGHT': 'Rear right',
  tireReport: 'Tire report',
  'tireType.ALL_SEASON': 'All seasons',
  'tireType.SUMMER': 'Summer',
  'tireType.UNSPECIFIED': 'Unspecified',
  'tireType.WINTER': 'Winter',
  'validation.email': 'Invalid email address',
  'validation.required': 'This field is mandatory',
  vehicle: 'vehicle',
  'web-online-payment.accept.additional.message':
    'The works will start upon reception of your validation and the deposit payment.',
  'web.404': 'Item not found',
  'web.absolutely': 'Absolutely',
  'web.accept': 'Accept',
  'web.accept-and-pay.deposit.selected.todo': 'Accept selected works and pay deposit ({price} incl. tax)',
  'web.accept-and-pay.selected.todo': 'Accept selected works and pay ({price} incl. tax)',
  'web.accept.salesOffer': 'Accept the offer',
  'web.accept.selected': 'Accept selected works',
  'web.accept.selected.todo': 'Accept selected works',
  'web.accepted.error': 'Works couldn’t be accepted.',
  'web.actual.km': 'Mileage:',
  'web.additional.accepted.tasks.title': '{count}x Additional works - Already answered',
  'web.additional.info': 'Additional Information',
  'web.additional.info.available': 'Additional information is available.',
  'web.additional.tasks': 'Additional works',
  'web.additional.tasks.accept.message': 'All selected works have been accepted. Thank you for your confirmation.',
  'web.additional.tasks.accept.title': 'Additional works',
  'web.additional.tasks.confirm.before.date.1': 'We would like to inform you of the performed checks and ask you',
  'web.additional.tasks.confirm.before.date.2': 'to please confirm if you wish to carry out the additional works.',
  'web.additional.tasks.confirm.before.date.3':
    'In order to ensure the return of your vehicle on the date and time initially agreed upon*, please',
  'web.additional.tasks.confirm.before.date.4': 'send us your confirmation before',
  'web.additional.tasks.confirm.before.date.inventory': '*Based on available inventory',
  'web.additional.tasks.refuse.message': 'All additional works are refused',
  'web.additional.tasks.refuse.title': 'Additional works',
  'web.additional.tasks.title': '{count}x Additional works',
  'web.additional.tasks.vehicle.check': 'Additional works following your vehicle check',
  'web.additional.tasks.workflow': 'Additional works',
  'web.advices.version.error': 'An error occurred while reloading the data. Please retry.',
  'web.advices.version.warning.aftersales': 'We have <b>updated</b> your <b>work order</b>, please refresh data.',
  'web.advices.version.warning.sales': 'We have <b>updated</b> your <b>offer</b>, please refresh data.',
  'web.advisor': 'Recommended',
  'web.all': 'All',
  'web.answer': 'Your reply was sent.',
  'web.answer.already.recorded': 'Your answer has already been recorded and you cannot modify it.',
  'web.answers': 'Answers',
  'web.appointments.attachments': 'Attachments',
  'web.appointments.billing': 'Billing',
  'web.appointments.billing.helpbox.alert': 'Please pay the works before picking up your vehicle',
  'web.appointments.billing.helpbox.description': 'We offer an online payment option.',
  'web.appointments.billing.works.title': '{count}x Items to pay',
  'web.appointments.booking.information': 'Please find the information about your safe in the corresponding section.',
  'web.appointments.client-documents': 'Your documents',
  'web.appointments.client-documents.add': 'Add a document',
  'web.appointments.client-documents.added-documents': 'Added documents',
  'web.appointments.client-documents.media.addedByDealership': 'Added by the dealership',
  'web.appointments.client-documents.media.error': 'Failed to upload this document, retry ?',
  'web.appointments.client-documents.media.status.accepted': 'Accepted',
  'web.appointments.client-documents.media.status.pending': 'Pending',
  'web.appointments.client-documents.media.status.refused': 'Refused',
  'web.appointments.client-documents.send': 'Send documents',
  'web.appointments.client-documents.send.confirm': 'We will verify the documents.',
  'web.appointments.client-documents.send.okText': 'Send',
  'web.appointments.client-documents.send.title': 'Send documents?',
  'web.appointments.client-documents.upload.error': 'Document(s) were not added',
  'web.appointments.client-documents.upload.success': 'Document(s) added',
  'web.appointments.client-documents.upload.warning':
    'Please use your smartphone to take a picture of the requested documents',
  'web.appointments.dropoff': 'Key drop-off',
  'web.appointments.dropoff.confirm.dropoff': 'I’ve dropped my keys',
  'web.appointments.dropoff.confirm.error': 'Cannot confirm key drop-off',
  'web.appointments.dropoff.confirm.modalContent': 'You’ll be notified once the safe has been checked',
  'web.appointments.dropoff.confirm.modalTitle': 'Confirm drop-off?',
  'web.appointments.dropoff.confirm.success': 'Key drop-off confirmed',
  'web.appointments.dropoff.dropoff-vehicle': 'Drop-off my vehicle',
  'web.appointments.dropoff.info.error': 'We’ve detected a problem with the content of the safe. Please contact us',
  'web.appointments.dropoff.info.pending':
    'You have confirmed having dropped off your keys. Our teams will check the safe',
  'web.appointments.dropoff.info.success': 'The safe verification is done. We confirm having retrieved your keys',
  'web.appointments.dropoff.locker.access': 'Access to the safe',
  'web.appointments.dropoff.locker.available': 'The safe will be available from {from} until {to}',
  'web.appointments.dropoff.locker.availableOn': 'Available from {dateTime}',
  'web.appointments.dropoff.locker.code': 'Access code',
  'web.appointments.dropoff.locker.open.error': 'Error when opening the locker',
  'web.appointments.dropoff.locker.open.locationId_mismatch': 'The locationId does not match your locker',
  'web.appointments.dropoff.locker.open.modal.input': 'Please enter the locationId present in the cabinet:',
  'web.appointments.dropoff.locker.open.modal.title': 'Confirm opening?',
  'web.appointments.dropoff.locker.open.success': 'Locker opened',
  'web.appointments.dropoff.locker.reference': 'Safe number',
  'web.appointments.locker.error': 'Your safe has not yet been prepared. Please contact us.',
  'web.appointments.locker.unavailable': 'Unavailable',
  'web.appointments.pickup': 'Key pick up',
  'web.appointments.pickup.confirm': 'I’ve picked up my keys',
  'web.appointments.pickup.confirm.error': 'Cannot confirm key pick up',
  'web.appointments.pickup.confirm.modalContent': 'You’ll be notified once the safe has been checked',
  'web.appointments.pickup.confirm.modalTitle': 'Confirm pick up?',
  'web.appointments.pickup.confirm.success': 'Key pick up confirmed',
  'web.appointments.pickup.info.error': 'We’ve detected a problem with the content of the safe. Please contact us',
  'web.appointments.pickup.info.pending':
    'You have confirmed having picked up your keys. Our teams will check the safe',
  'web.appointments.pickup.info.success': 'The safe verification is done',
  'web.appointments.pickup.vehicle': 'Pick my vehicle',
  'web.appointments.rental-vehicle': 'Rental vehicle',
  'web.appointments.rental-vehicle.advice.add': '+ Add damages',
  'web.appointments.rental-vehicle.advice.type': 'Damage type',
  'web.appointments.rental-vehicle.advice.upload': 'Attach pictures',
  'web.appointments.rental-vehicle.damages': 'Describe damages',
  'web.appointments.rental-vehicle.damages.confirm': 'Report issues',
  'web.appointments.rental-vehicle.damages.confirm.failure': 'Cannot report issue(s) with rental vehicle',
  'web.appointments.rental-vehicle.damages.confirm.modal.content': 'We will be alerted and will contact you shortly.',
  'web.appointments.rental-vehicle.damages.confirm.modal.okButton': 'Signal',
  'web.appointments.rental-vehicle.damages.confirm.modal.title': 'Signal damages ?',
  'web.appointments.rental-vehicle.damages.confirm.success': 'Issue(s) with rental vehicle reported',
  'web.appointments.rental-vehicle.documents': 'Documents',
  'web.appointments.rental-vehicle.documents.checkbox': 'I have taken notice and accept the documents',
  'web.appointments.rental-vehicle.documents.confirm': 'Accept documents',
  'web.appointments.rental-vehicle.documents.confirm.failure': 'Cannot accept document(s)',
  'web.appointments.rental-vehicle.documents.confirm.modal.content':
    'By accepting those documents, you electronically sign them and are liable for their content.',
  'web.appointments.rental-vehicle.documents.confirm.modal.title': 'Accept documents?',
  'web.appointments.rental-vehicle.documents.confirm.success': 'Document(s) accepted',
  'web.appointments.rental-vehicle.documents.submit': 'Accept documents',
  'web.appointments.rental-vehicle.information':
    'If you notice undeclared damages on the vehicle audit, thanks to list them below and add pictures if necessary.',
  'web.appointments.rental-vehicle.issues': 'Vehicle issues',
  'web.appointments.rental-vehicle.vehicle': 'Vehicle',
  'web.appointments.repair-order': 'Repair order',
  'web.appointments.works.accept': 'Accept works',
  'web.appointments.works.accept.selected': 'Accept selected works',
  'web.appointments.works.done': 'Required works',
  'web.appointments.works.done.confirm': 'I have taken notice and accept the works recommended on my vehicle',
  'web.appointments.works.done.confirm.error': 'Please confirm the required works',
  'web.appointments.works.done.title': '{count}x Required works',
  'web.appointments.works.help': 'Please take notice of required works.',
  'web.appointments.works.total.done': 'Total required works (excl. tax)',
  'web.appointments.works.total.done.vat': 'Total required works (incl. tax)',
  'web.attentionPoints': 'Attention points',
  'web.back': 'Back',
  'web.bookmark.high': 'Urgent',
  'web.bookmark.low': 'Attention',
  'web.brand': 'Brand',
  'web.brand.dot': 'Brand:',
  'web.call.me.back': "I'd like to be called back",
  'web.calls.default.delete': 'Entity deleted',
  'web.calls.default.failure': 'Oops! Something went wrong.',
  'web.calls.default.post': 'Entity has been created with success',
  'web.calls.default.put': 'Entity updated',
  'web.callUs': 'Call us',
  'web.cancel': 'Cancel',
  'web.chassis': 'Chassis:',
  'web.chassis.number': 'Chassis Number:',
  'web.chat.message.closedWarning':
    'This appointment is over - you may no longer chat with your dealership here. Please contact your dealership directly.',
  'web.chat.message.us': 'Message us',
  'web.chat.message.waiting.plural':
    '{count, plural, one {A message is waiting for you} other {Messages are waiting for you}}',
  'web.chat.messages.types.email': 'E-mail',
  'web.chat.messages.types.internal': 'Chat',
  'web.chat.messages.types.sms': 'SMS',
  'web.check.all': 'Check all',
  'web.checklists.accessory.title': 'Accessories and services',
  'web.checklists.discount.title': 'Discount',
  'web.checklists.tradeIn.title': 'Trade in',
  'web.checklists.vehicle.title': 'Vehicle',
  'web.civility': 'Civility',
  'web.close': 'Close',
  'web.coach.date': '27th June, 9h45',
  'web.coach.madeby': 'Made by',
  'web.coach.maintitle': 'Vincent Salimon addresses you: watch the video about your commitment!',
  'web.coach.subtitle': 'BMW Brandstone George V',
  'web.coach.subtitle2': '38 Avenue George V',
  'web.coach.subtitle3': '75008 Paris',
  'web.coach.title': 'Change Factory #3',
  'web.comment.date': 'on {0} in {1}',
  'web.comment.failure': 'An error occurred when sending your message',
  'web.comment.message': 'Message',
  'web.comment.messages': 'Messages',
  'web.comment.reply': 'Reply',
  'web.comment.reply.failure': 'Message not sent',
  'web.comment.reply.success': 'Message sent',
  'web.comment.show.all': 'Show all messages',
  'web.comment.success': 'Your message has been successfully sent',
  'web.comment.your.message': 'Your message',
  'web.comment.your.message.required': 'Please type a message.',
  'web.comment.your.name': 'Your name',
  'web.common.keyValue': '{key}: {value}',
  'web.common.media': 'Media{withCount, select, true { ({nbMedias})} other {}}',
  'web.complementary.information': 'Complementary information on a vehicle',
  'web.confirm': 'Confirm',
  'web.contact-form.consent':
    'I consent to having this website store my submitted information so they can respond to my inquiry.',
  'web.contact-form.consent.link':
    'I consent to having this website store my submitted information so they can respond to my inquiry. The privacy policy is available at <a>this link</a>.',
  'web.contact-form.failure': 'An error has occurred while sending your request',
  'web.contact-form.fill': 'Please complete the form below to be contacted.',
  'web.contact-form.interested': 'Are you interested in this vehicle ?',
  'web.contact-form.message': 'Hello,\n\nI would like to receive more information about this vehicle.\n\nSincerely',
  'web.contact-form.success': 'Your request has been sent',
  'web.contact-form.title': 'Contact Form',
  'web.contact.person': 'Contact Person',
  'web.contact.us': 'Contact us',
  'web.contact.your.person': 'Your contact person',
  'web.cookies.acceptAll': 'Accept all',
  'web.cookies.analyticsDescription':
    'We use this data to improve the performance of our websites and services, as well as to conduct user experience and business-relevant analysis. These services collect information about how you use the website, like which pages you visited and which links you clicked on. Their sole purpose is to improve website functions. This includes cookies from third-party analytics services as long as the cookies are for the exclusive use of Fleetback.',
  'web.cookies.analyticsTitle': 'Web performance and analytics',
  'web.cookies.content':
    '<p>Fleetback uses cookies and other technologies to keep the website reliable and secure, and to measure performance. To do this, we collect information about users, their behavior, and their devices.</p><p>If you select "Accept all", you accept this and agree that we may share this information with third parties, such as our marketing partners and analytics services. Select "Set preferences" for further details and to manage your options.</p><span>For more information, please read our <a>privacy notice</a>.</span>',
  'web.cookies.essentialDescription':
    'We collect and process essential data useful for you to browse Fleetback, use its features, for the technical performance of the website, as well as for security purposes.',
  'web.cookies.essentialTitle': 'Essential',
  'web.cookies.onlyEssential': 'Only essential',
  'web.cookies.preferences': 'Set preferences',
  'web.cookies.savePreferences': 'Save preferences',
  'web.cookies.settingsTitle': 'Privacy preferences',
  'web.cookies.title': 'We value your privacy',
  'web.currently.logged.in': 'You are currently logged in Fleetback and see this page in',
  'web.custom-template.cancel.modal.body': 'All changes will be lost. Do you want to continue?',
  'web.custom-template.cancel.modal.title': 'Warning!',
  'web.custom-template.change-all': 'Apply to all the languages',
  'web.custom-template.custom-advertising.popup.title': 'Customized advertising',
  'web.custom-template.custom-banner.popup.content':
    'The image size must be less than 5Mb. The image format must be in JPEG, PNG or GIF.',
  'web.custom-template.custom-banner.popup.title': 'Customized banner',
  'web.custom-template.custom-logo.popup.title': 'Customized logo',
  'web.custom-template.custom-message.popup.content': 'The maximum message size is 50 characters.',
  'web.custom-template.custom-message.popup.title': 'Customized message',
  'web.custom-template.drop-ads': 'Drop a new image',
  'web.custom-template.drop-image': 'Drop the banner',
  'web.custom-template.drop-logo': 'Drop the logo',
  'web.custom-template.edit': 'Edit',
  'web.custom-template.error.file_too_big': 'The file exceed the limit of {0} MB.',
  'web.custom-template.error.invalid_file_type': 'The file type is invalid.',
  'web.custom-template.error.unknown': 'An error is occurred while the upload of file.',
  'web.custom-template.image.popup.content':
    'The image size must be less than 2Mb. The image format must be in JPEG, PNG or GIF.',
  'web.custom-template.modal.body': 'Template name',
  'web.custom-template.modal.body_save': 'The custom template will automatically be set and applied.',
  'web.custom-template.modal.body_warning': 'Attention: make sure to apply the changes to all languages.',
  'web.custom-template.modal.title': 'Enter the name of the custom template',
  'web.custom-template.page.title': '{name} - Customize',
  'web.custom-template.preview': 'Preview',
  'web.custom-template.save': 'Save',
  'web.custom-template.save.error': 'The template was not saved.',
  'web.custom-template.save.success': 'The template has been saved successfully.',
  'web.custom-template.upload-ads': 'Add a new image',
  'web.custom-template.upload-image': 'Edit the banner',
  'web.custom-template.upload-logo': 'Edit the logo',
  'web.customer-number': 'Customer number',
  'web.customer-number.dot': 'Customer number:',
  'web.customize.originalTemplate': 'Original template:',
  'web.dealership-payment.button': 'Pay at the dealership',
  'web.dealership-payment.error': 'An error occurred while you asked to pay at dealership.',
  'web.dealership-payment.pending.confirm': 'I confirm that I understand I may be making a second payment',
  'web.dealership-payment.pending.message':
    'A payment is pending. Be aware that processing time to validate the payment can take some time. Proceed to payment a second time only if you are sure that your payment has been rejected.',
  'web.dealership-payment.pending.title': 'Payment in progress',
  'web.dealership-payment.success': 'You asked to pay at dealership.',
  'web.dealership-payment.sure': 'Are you sure that you want to pay at dealership?',
  'web.documents': 'Documents',
  'web.documents.available': 'Documents available with your vehicle check :',
  'web.documents.consult': 'Consult',
  'web.documents.less': 'Show less',
  'web.documents.linked': 'Linked documents',
  'web.documents.more': 'Show more',
  'web.documents.sign.button': 'Sign {count, plural, one {document} other {documents}}',
  'web.documents.sign.warning': 'Please review and sign the {count, plural, one {document} other {documents}} below',
  'web.documents.tscan': 'Tire Diagnostics',
  'web.download': 'Download',
  'web.download.media': 'Download media',
  'web.dsa': 'Digital Services Act',
  'web.element.good.condition': 'good condition',
  'web.element.good.condition.plural':
    '{elements, plural, one {# element in} other {# elements in}} <b>good condition</b>',
  'web.element.plural': 'elements in',
  'web.element.singular': 'element in',
  'web.email': 'Email address',
  'web.email.dot': 'Email address:',
  'web.endDate': 'End date: {endDate}',
  'web.error.description.Gone': 'If you believe this is a mistake, please contact us in order to get a new link.',
  'web.error.file.common': 'An error has occurred.',
  'web.error.file.not-an-image': 'The file is not a valid image.',
  'web.error.file.resolution-too-big': 'The image resolution is too big.',
  'web.error.file.resolution-too-low': 'The image resolution is too low.',
  'web.error.file.title': 'File error',
  'web.error.notfound': 'File not found.',
  'web.error.page.notfound': 'Page not found',
  'web.error.page.title': '{name} - Error',
  'web.error.title.Gone': 'This page is no longer available',
  'web.events.title': 'Activity history',
  'web.exploded.question.no.pins': 'No damage spotted',
  'web.file-update': 'File update',
  'web.file.closed': 'This file is archived and you cannot modify it.',
  'web.filter': 'Filter',
  'web.finalInvoice.forInformation': 'For information, please find below the invoice for your appointment.',
  'web.finalInvoice.modal.button': 'View changes',
  'web.finalInvoice.modal.description': 'Your invoice has been modified',
  'web.finalInvoice.reference': 'Invoice number',
  'web.finalInvoice.successfulPayment': 'Payment successful',
  'web.finalInvoice.title': 'Final invoice',
  'web.finalInvoice.total': '<b>Amount to be paid</b> (incl. tax)',
  'web.finalInvoice.total_information': '<b>Invoice amount</b> (incl. tax)',
  'web.finalInvoice.total_paid': '<b>Paid amount</b> (incl. tax)',
  'web.finalInvoice.worksWarning':
    'Pending works can no longer be accepted or refused as the final invoice has been issued.',
  'web.find.us': 'Find us',
  'web.firstname': 'First name',
  'web.footer':
    'All prices include labor costs.{withInitialRepairs, select, true { The amount of this quote does not include the initial repairs.} other {}}{withGuaranteedPrices, select, true { Prices are guaranteed for a duration of 30 days from the date of the vehicle check.} other {}}',
  'web.footer.noPricesHelper':
    'Note: Items without price do not indicate they will be provided free of charge. Their final price has not yet been set, will be determined later and communicated to you accordingly.',
  'web.footer.unsubscribe': 'Click here to unsubscribe',
  'web.for.information': 'For information',
  'web.for.team': 'For the {0} team,',
  'web.for.team.after': 'team,',
  'web.for.team.before': 'For the',
  'web.fuels.DIESEL': 'Diesel',
  'web.fuels.ELECTRIC': 'Electric',
  'web.fuels.GASOLINE': 'Gasoline',
  'web.fuels.HYBRID': 'Hybrid',
  'web.fuels.OTHER': 'Other',
  'web.fuelType': 'Fuel type:',
  'web.general.terms.conditions': 'General terms and conditions',
  'web.ht': 'excl. tax',
  'web.if.reply':
    "If you reply before {dateTime}, we'll be able to carry out these works before you pick up your vehicle at the date and time initially agreed",
  'web.important': 'Important',
  'web.info.meets.expectations': 'Did the information provided meet your expectations?',
  'web.inspectionDate': 'Vehicle inspection due date:',
  'web.interested.car.information': 'Car Information',
  'web.interested.car.message':
    "You've shown your interest for the following vehicle. Please provide us your contact information so that we can contact you.",
  'web.interested.client.civility': 'Civility',
  'web.interested.client.civility.select': 'Please select',
  'web.interested.client.contactme': 'Contact me',
  'web.interested.client.email': 'EMAIL',
  'web.interested.client.firstname': 'First name',
  'web.interested.client.lastname': 'Last name',
  'web.interested.client.mandatory': 'Fields with a * are mandatory',
  'web.interested.client.phone': 'Phone Number',
  'web.interested.client.recontact': 'I authorize you to contact me',
  'web.interested.client.testdrive': 'I want a test drive',
  'web.interested.client.title': 'Contact information',
  'web.interested.fail': 'Your request has not been sent',
  'web.interested.success': 'Your request has been successfully sent',
  'web.interested.title': 'Interested in this car?',
  'web.intervention.fiche': 'File',
  'web.invoice': 'Invoice(s)',
  'web.invoice.print': 'Print the invoice',
  'web.keydeposit.notification.confirm.error': 'Cannot confirm works to accept.',
  'web.keydeposit.notification.confirm.success': 'Works sent successfully.',
  ...Object.fromEntries(ALL_LANGUAGES.map((language) => [`web.languageDropdown.${language}`, language.toUpperCase()])),
  'web.lastname': 'Last name',
  'web.leads.unsubscribe.failure': 'An error occurred when unsubscribing you.',
  'web.leads.unsubscribe.success': 'You have successfully been unsubscribed.',
  'web.media': 'Linked media',
  'web.media.error.notallowed': 'Access not allowed',
  'web.media.error.notfound': 'Media not found',
  'web.media.gallery': 'Media gallery',
  'web.media.linked': 'Linked media',
  'web.media.play.explanatory.video': 'Play the explanatory video provided by your technician',
  'web.message': 'Message',
  'web.message.from.appointment.service':
    'Thank you for taking an appointment in our dealership. You will find the instructions hereafter.',
  'web.messages.prefix': 'You may chat with your dealership here.',
  'web.mileage': 'Mileage:',
  'web.millimeters': '{value}mm',
  'web.model': 'Model:',
  'web.name': 'Name',
  'web.name.dot': 'Name:',
  'web.new': 'New',
  'web.new-advices.modal.description.aftersales': '<b>New works</b> have been <b>added</b> to your work order',
  'web.new-advices.modal.description.sales': '<b>New items</b> have been <b>added</b> to your offer',
  'web.new-advices.modal.goto.aftersales': 'Go to new works',
  'web.new-advices.modal.goto.sales': 'Go to new items',
  'web.offer.accept-and-pay.deposit.selected.todo': 'Accept the offer and pay deposit ({price})',
  'web.offer.accept-and-pay.selected.todo': 'Accept the offer and pay ({price})',
  'web.offer.accept.failure': 'An error has occurred while accepting the offer',
  'web.offer.notSelected': 'Select this offer',
  'web.offer.refuse.failure': 'An error has occurred while refusing the offer',
  'web.offer.select_offer.ACCEPTED': 'Accepted',
  'web.offer.select_offer.PARTS': 'Select an offer',
  'web.offer.select_offer.SALES': 'Select vehicle',
  'web.offer.selected': 'Selected',
  'web.offer.timeToReply': 'This offer is valid until {date}.',
  'web.offer.timeToReply.after': 'This offer was valid until {date}. It cannot be accepted anymore.',
  'web.offered': 'Offered',
  'web.online': 'Online',
  'web.online-payment.abort': 'Interrupted transaction - Nothing has been charged.',
  'web.online-payment.alreadypaid': 'Paid',
  'web.online-payment.amount': 'Transaction amount: {value}',
  'web.online-payment.button': 'Proceed with checkout',
  'web.online-payment.button-deposit': 'Pay all the offer',
  'web.online-payment.button.deposit': 'Pay deposit ({price})',
  'web.online-payment.button.withPrice': 'Proceed with checkout ({price})',
  'web.online-payment.deposit': 'deposit',
  'web.online-payment.deposit-button': 'Pay the deposit online',
  'web.online-payment.deposit-button.offer': 'Pay the deposit online',
  'web.online-payment.deposit-message':
    'A deposit {hasDeposit, select, true {of {depositPercentage}%} other {}} is required before starting works.',
  'web.online-payment.deposit-message.generic':
    'A deposit {hasDeposit, select, true {of {depositPercentage}%} other {}} is required.',
  'web.online-payment.deposit-message.offer':
    '{hasDeposit, select, true {{depositPercentage}% deposit} other {Deposit}} due upon order',
  'web.online-payment.deposit.failure': 'An error has occurred during the deposit payment.',
  'web.online-payment.description':
    'We offer an online payment option. You can pay your entire invoice directly below before picking up your vehicle.',
  'web.online-payment.error.high': 'The amount to pay is too high',
  'web.online-payment.error.low': 'The amount to pay is insufficient',
  'web.online-payment.failure': 'An error has occurred during the payment.',
  'web.online-payment.handled': 'Your payment of {0} has been taken into account on the {1} at {2}.',
  'web.online-payment.handled.deposit':
    'Your deposit of {0} %, for a total of {1}, has been taken into account on the {2} at {3}.',
  'web.online-payment.info': 'Payment history',
  'web.online-payment.intervention_of': 'File of',
  'web.online-payment.lefttopay.aftersales':
    'This transaction corresponds to a deposit of {deposit} on {total} of additional works.',
  'web.online-payment.lefttopay.offer':
    'This transaction corresponds to a deposit of {deposit} on an offer of {total}.',
  'web.online-payment.lefttopay.with.vat': 'Left to pay (incl. tax)',
  'web.online-payment.lefttopay.without.vat': 'Left to pay (excl. tax)',
  'web.online-payment.legal':
    'By using the online payment service, you consent to the use of your personal data in order to identify the transaction.',
  'web.online-payment.method': 'Payment method: {value}',
  'web.online-payment.methods': 'Payment methods',
  'web.online-payment.methodsDescription': 'Here are the methods of payment accepted at the dealership.',
  'web.online-payment.modal.content': 'Your payment status has been updated, please refresh data.',
  'web.online-payment.others': 'Others',
  'web.online-payment.payment': 'payment',
  'web.online-payment.success': 'Your payment of {0} {1} has been successful.',
  'web.online-payment.success.feedback': 'Your payment has been successful.',
  'web.online-payment.title': 'Online payment',
  'web.online-payment.total': 'Total',
  'web.online-payment.totalalreadypaid': 'Total already paid',
  'web.online-payment.totalPaid': 'Total paid',
  'web.online-payment.totaltopay': 'Total to pay',
  'web.online-payment.work': 'Work',
  'web.online-payment.work-required': 'Additional work',
  'web.online-payment.works': 'Works',
  'web.online-payment.works-required': 'Additional works',
  'web.opinion.failure': 'Your opinion couldn’t be send.',
  'web.opinion.matters': 'Your opinion matters',
  'web.opinion.success': 'Your opinion has been sent.',
  'web.our.answer': 'Our answer',
  'web.parts.footer.title': 'Summary',
  'web.parts.section.alreadyAnswered': '{count}x already answered items',
  'web.parts.section.proposed': '{count}x proposed items',
  'web.parts.section.title': 'Offer details',
  'web.payerName': 'Billing: {name}',
  'web.payerPrice': '(Price: {price})',
  'web.payment': 'Payment',
  'web.payments.failure': 'Payment failed',
  'web.payments.fetchError': 'An error occurred while getting payments information',
  'web.payments.success': 'Payment succeeded',
  'web.phonenumber': 'Phone number',
  'web.phonenumber.dot': 'Phone number:',
  'web.pictures': 'Pictures',
  'web.please.validate.choice': 'Please validate the additional works our technicians have identified on your vehicle.',
  'web.please.validate.refuse': 'You have refused the following works.',
  'web.please.validate.selected': 'You have confirmed the following selected works.',
  'web.points.of.interest': 'Points of interest in the video',
  'web.powered.by': 'Powered by',
  'web.preview.mode': 'preview mode',
  'web.promo.date': '17th october, 12h',
  'web.promo.item.1': 'Personalized service experience',
  'web.promo.item.2': 'Increase your sales',
  'web.promo.item.3': 'Win time',
  'web.promo.item.4': 'A complete transparency',
  'web.promo.item.5': 'Create quality audits simply',
  'web.promo.item.6': 'For sales, after-sales, guaranty and quality control',
  'web.promo.madeby': 'Made by',
  'web.promo.maintitle': 'BMW Dealer Convention 2016',
  'web.promo.subtitle': '19 Avenue Kléber',
  'web.promo.subtitle2': 'Paris, France, 75116',
  'web.promo.title': 'The Peninsula Paris',
  'web.quote': 'Quote',
  'web.rating.commentPlaceholder': 'Tell us what went wrong',
  'web.rating.error': 'Can’t send your feedback',
  'web.rating.info': 'How would you rate the quality of the information received?',
  'web.rating.send': 'Send my review',
  'web.rating.sendGoogle': 'Publish my review on google',
  'web.rating.sendUpdate': 'Edit my review',
  'web.rating.sent': 'Thank you for your review!',
  'web.rating.star.plural': 'stars',
  'web.rating.star.singular': 'star',
  'web.rating.success': 'Feedback sent',
  'web.rating.title': 'Your feedback matters',
  'web.recommended.task': 'Recommended',
  'web.reference': 'Reference:',
  'web.refresh.data': 'Refresh data',
  'web.refresh.oops': 'Oops!',
  'web.refresh.page': 'Refresh the page',
  'web.refresh.pleaseRefresh': 'Please click refresh button to reload the page.',
  'web.refresh.somethingWrong': "Something's gone wrong...",
  'web.refuse.all': 'Refuse all works',
  'web.refuse.salesOffer': 'Reject the offer',
  'web.regards': 'Kind regards',
  'web.registration': 'Plate number:',
  'web.registrationDate': 'First registration:',
  'web.reminder.accepted.tasks.title': '{count}x Works reminded - Already answered',
  'web.reminder.appointment': "Let's schedule an appointment to get those works done.",
  'web.reminder.tasks.title': '{count}x Works reminded',
  'web.reminder.work-to-plan': 'Work to plan',
  'web.reminder.works-to-plan': 'Works to plan',
  'web.retry': 'Retry',
  'web.sales.warning': '',
  'web.section.audit': 'Audit',
  'web.section.photo': 'Your photos',
  'web.section.video': 'Your videos',
  'web.select.at.least.one': 'Please select an answer',
  'web.select.at.least.one.task': 'Please select at least one work to accept',
  'web.select.at.least.one.vehicle-or-accessory':
    'Please select at least one {hasVehicle, select, true {vehicle to accept} other {accessory}}',
  'web.send': 'Send',
  'web.spikeseed': 'Fleetback',
  'web.spikeseed.href': 'https://www.discover.fleetback.com/',
  'web.startDate': 'Start date: {startDate}',
  'web.supplementary.tasks.info': 'You will find more information hereafter.',
  'web.supplementary.tasks.number': 'Number of works identified by our technicians',
  'web.sure.accept.additional.message': 'The works will be performed upon reception of your validation.',
  'web.sure.accept.all.tasks': 'Are you sure you want to accept the selected required works?',
  'web.sure.accept.general.conditions.accept':
    'I accept {hasGeneralTerms, select, true {<terms>the general terms and conditions</terms>} other {}}{hasBoth, select, true { and } other {}}{hasConfidentialityPolicy, select, true {<policy>the data handling policy</policy>} other {}}.',
  'web.sure.accept.offer': 'Are you sure you want to accept the offer?',
  'web.sure.accept.withdrawal.rights':
    'I have consented to the execution of the contract before the withdrawal period ends and acknowledge that the right to withdraw will expire upon the commencement of the contract’s execution.',
  'web.sure.refuse.all.tasks': 'Are you sure you want to refuse all required works?',
  'web.sure.refuse.offer': 'Are you sure you want to refuse the offer?',
  'web.tab.offers.title': 'Offer',
  'web.tab.parts.title': 'Parts offer',
  'web.task.discount': 'With a discount of {value}',
  'web.tasks.element.plural': 'works',
  'web.tasks.element.plural.recommended': 'are recommended',
  'web.tasks.element.plural.urgent': 'are urgent',
  'web.tasks.element.recommended.plural':
    '{count, plural, one {# <b>recommended</b> work} other {# <b>recommended</b> works}}',
  'web.tasks.element.singular': 'work',
  'web.tasks.element.singular.recommended': 'is recommended',
  'web.tasks.element.singular.urgent': 'is urgent',
  'web.tasks.element.urgent.plural': '{count, plural, one {# <b>urgent</b> work} other {# <b>urgent</b> works}}',
  'web.tasks.with.vat': 'Show prices incl. tax',
  'web.tasks.with.vat.v2': 'incl. tax',
  'web.team': '{name} team',
  'web.technicians.identified.additional.donetasks': 'Please find a summary of the completed services',
  'web.technicians.identified.additional.remindertask':
    'Our customer service has identified work to plan on your vehicle.',
  'web.technicians.identified.additional.remindertasks':
    'Our customer service has identified works to plan on your vehicle.',
  'web.technicians.identified.additional.replied': 'Thanks for your reply. You will find the report below.',
  'web.technicians.identified.additional.summary1': 'Our mechanics have identified',
  'web.technicians.identified.additional.summary2':
    '{0} additional maintenance operation(s) that your vehicle requires.',
  'web.technicians.identified.additional.tasks':
    'Our technicians have identified additional works to be carried out on your vehicle.',
  'web.technicians.performed.checks': 'Our team has performed {0} verification(s) on your vehicle.',
  'web.temoignage.contact': 'Cyril Jacquin',
  'web.temoignage.ending': 'Bien à vous',
  'web.temoignage.greetings': 'Chers Concessionnaires',
  'web.temoignage.message':
    'Vous êtes près de 250 collaborateurs à désormais partager la Vision Commune proposée lors du programme « Excitement in Service » ! Vos homologues des Concessions suivant le programme à leur tour vous rejoindront prochainement.',
  'web.temoignage.message2':
    'Ainsi, je tenais à vous remercier chaleureusement pour votre implication durant les sessions animées par votre coach et votre itinérant. C’est votre implication et votre engagement qui ont également permis de faire de cette première vague un succès. A cette occasion, je vous invite à visionner le témoignage de Philippe qui, je l’espère, fera écho à votre propre expérience du programme.',
  'web.temoignage.message3':
    'Comme un succès ne se construit jamais seul, je vous prie de transmettre mes félicitations à l’ensemble de vos collaborateurs qui œuvrent quotidiennement à proposer un expérience unique à vos clients.',
  'web.temoignage.message4':
    'Vous disposez maintenant des atouts qui vous permettront de pérenniser les actions mises en place et de continuer à susciter l’enthousiasme dans l’univers de la mobilité!',
  'web.timeline.counter': 'Step: <value>{position}/{total}</value>',
  'web.timeline.title': 'File follow-up',
  'web.to': 'to',
  'web.toggle': 'Toggle',
  'web.total': 'Total (excl. tax)',
  'web.total.alreadyAccepted': 'Total already accepted (excl. tax)',
  'web.total.alreadyAccepted.vat': 'Total already accepted (incl. tax)',
  'web.total.alreadyAcceptedItems': 'Total accepted items (excl. tax)',
  'web.total.alreadyAcceptedItems.vat': 'Total accepted items (incl. tax)',
  'web.total.alreadyPaid': 'Total already paid (excl. tax)',
  'web.total.alreadyPaid.vat': 'Total already paid (incl. tax)',
  'web.total.discount': 'Discount (excl. tax)',
  'web.total.discount.vat': 'Discount (incl. tax)',
  'web.total.done': 'Total pre-approved works (excl. tax)',
  'web.total.done.vat': 'Total pre-approved works (incl. tax)',
  'web.total.doneItems': 'Total pre-approved items (excl. tax)',
  'web.total.doneItems.vat': 'Total pre-approved items (incl. tax)',
  'web.total.leftToPay': 'Left to pay (excl. tax)',
  'web.total.leftToPay.vat': 'Left to pay (incl. tax)',
  'web.total.newItems': 'Total new items (excl. tax)',
  'web.total.newItems.vat': 'Total new items (incl. tax)',
  'web.total.newWorks': 'Total accepted works (excl. tax)',
  'web.total.newWorks.vat': 'Total accepted works (incl. tax)',
  'web.total.parts': 'Total accepted items (excl. tax)',
  'web.total.parts.vat': 'Total accepted items (incl. tax)',
  'web.total.payRemaining': 'Pay remaining amount ({price})',
  'web.total.recommended': 'Total additional works (excl. tax)',
  'web.total.recommended.vat': 'Total additional works (incl. tax)',
  'web.total.reminder': 'Total works reminded (excl. tax)',
  'web.total.reminder.vat': 'Total works reminded (incl. tax)',
  'web.total.tax': 'Tax ({vat}%)',
  'web.total.tradeIn': 'Trade in (excl. tax)',
  'web.total.tradeIn.vat': 'Trade in (incl. tax)',
  'web.total.vat': 'Total (incl. tax)',
  'web.total.withoutDiscount': 'Total without discount (excl. tax)',
  'web.total.withoutDiscount.vat': 'Total without discount (incl. tax)',
  'web.totals.accepted.tasks': 'Totals of accepted works',
  'web.ttc': 'incl. tax',
  'web.units.in_1_32': '/32"',
  'web.units.km': 'km',
  'web.units.mi': 'mi',
  'web.units.mm': 'mm',
  'web.update': 'Update',
  'web.upload.failure': 'The file was not uploaded.',
  'web.upload.failure.size': 'The file was not uploaded. The image size is too big.',
  'web.upload.failure.type': 'The file was not uploaded. The only format allowed is jpeg.',
  'web.upload.success': 'The file has been uploaded with success',
  'web.upload.text': 'Drop files here or click to upload',
  'web.urgent': 'Urgent',
  'web.urgent.task': 'Urgent',
  'web.validation.required': 'This field is mandatory',
  'web.vehicle.check': 'Vehicle check results',
  'web.vehicle.check.date': 'See the details of the vehicle check performed on the {date}',
  'web.vehicle.check.technicians':
    'Following your appointment in our workshop and in accordance with our quality requirements, our technicians have performed a <b>complete check of your vehicle</b> on the {date}.',
  'web.vehicle.description': 'Description',
  'web.vehicle.tyres': 'Tires',
  'web.videos': 'Videos',
  'web.visit.workshop.on': 'Your visit in our workshop on',
  'web.warning': 'Warning',
  'web.warning.connection-lost': 'The connection has been lost. Please refresh the page.',
  'web.welcome.to': 'Welcome to',
  'web.work.report.already.called.back': 'You asked to be called back',
  'web.work.report.take.appointment': 'Make an appointment',
  'web.work.report.tasks.scheduled': 'Recommended works',
  'web.workflow.vehicule-report.no-answer': 'No answer provided',
  'web.workflow.vehicule-report.no-media': 'No media provided',
  'web.works.done.title': '{count}x Pre-approved works',
  'web.works.doneItems.title': '{count}x Pre-approved items',
  'web.works.recommended': 'Recommended for you',
  'web.works.refuse.all': 'Refuse all works',
  'web.works.title': 'Work order',
  'web.your.contact': 'Your contact',
  'web.your.dealer': 'Your {0} dealership',
  'web.your.dealer.camping': 'You distributor of {0}',
  'web.your.dealer.no.brand': 'Your dealership',
  'web.your.vehicle': 'Your vehicle',
  'webhook.whatsapp.received_registration':
    'Thank you for registering. You will receive upcoming updates about your vehicle in this conversation.',
  'webhook.whatsapp.request_registration':
    'Hello and welcome to our follow-up service.\nTo register your vehicle, please send us your license plate number.',
  'whatsapp.template.fleetback_new_message.body':
    'Hello, the dealership has a new message for you. Click "Yes" to continue the conversation or ignore to end it.',
  'whatsapp.template.fleetback_new_message.yes': 'Yes',
};

export const dealer = {
  country: {
    code: 'fr',
    prefix: 33,
    valueAddedTax: 20,
    currency: '€',
    currencyIsoCode: 'eur',
    senderIdAllowed: true,
    appCountry: true,
    name: 'FRANCE',
    timezones: {
      'Europe/Luxembourg': '+02:00',
    },
  },
  timezone: 'Europe/Luxembourg',
  allowReminder: true,
  allowOnlinePayment: true,
  carConfigurator: {
    allowCarConfigurator: true,
  },
  shortId: 'NPKTc',
  displayWorksOk: false,
  valueAddedTax: 21,
  group: {
    name: 'Spikeseed',
    id: '95bed4c9-85e5-3b64-a9c4-89ad4c8e7485',
  },
  allowLockerBooking: true,
  defaultAppointmentFrom: '12:00:00',
  defaultAppointmentTo: '00:00:00',
  forceLiveDrivingLicense: false,
  allowMediaClipping: true,
  createRemindersFromSeverity: true,
  allowPlanetVoExport: false,
  blockNullPrice: false,
  allowSalesRating: true,
  allowAfterSalesRating: true,
  enforceAfterSalesChecklistCategories: false,
  enforceSalesChecklistCategories: true,
  daysBeforeSendReminder: 14,
  daysBeforeSendSeverityHigh: 14,
  daysBeforeSendSeverityLow: 30,
  selectedOfferedWorksChecklist: 'fc21df4c-55e1-4696-8afa-c2d9e6c122f6',
  paymentProvider: 'STRIPE',
  predefinedMessages: [],
  onlinePaymentEnabledByDefault: {
    SALES: true,
    TECHNICIAN: true,
  },
  customerDefaultLanguage: 'fr',
  name: '0_MyDealership Luxembourg',
  id: '67e7a0d7-a8a1-320f-bbb9-86df3750920e',
  units: {
    smallDistanceUnit: SmallDistanceUnit.IN_1_32,
    largeDistanceUnit: LargeDistanceUnit.MI,
  },
};

export const pgaDealer = {
  country: {
    code: 'fr',
    prefix: 33,
    valueAddedTax: 20,
    currency: '€',
    currencyIsoCode: 'eur',
    senderIdAllowed: true,
    appCountry: true,
    name: 'FRANCE',
    timezones: {
      'Europe/Luxembourg': '+02:00',
    },
  },
  timezone: 'Europe/Luxembourg',
  allowReminder: false,
  allowOnlinePayment: false,
  paymentProvider: 'STRIPE',
  carConfigurator: {
    allowCarConfigurator: false,
  },
  shortId: '0lBti',
  displayWorksOk: false,
  valueAddedTax: 20,
  group: {
    name: 'Emil Frey France',
    id: '293ecf45-4f68-3bc5-a713-a5887f4c1219',
  },
  allowLockerBooking: false,
  forceLiveDrivingLicense: false,
  allowMediaClipping: false,
  createRemindersFromSeverity: false,
  allowPlanetVoExport: false,
  blockNullPrice: false,
  allowSalesRating: false,
  allowAfterSalesRating: false,
  enforceAfterSalesChecklistCategories: false,
  enforceSalesChecklistCategories: false,
  daysBeforeSendReminder: 14,
  daysBeforeSendSeverityHigh: 14,
  daysBeforeSendSeverityLow: 30,
  selectedOfferedWorksChecklist: '60634c76-73c2-3275-9667-9eec9d20b2d1',
  onlinePaymentEnabledByDefault: {
    TECHNICIAN: true,
  },
  customerDefaultLanguage: 'fr',
  name: 'Peugeot Béziers',
  id: '796edd91-aa84-3a66-a772-2060d8a5436e',
  units: {
    smallDistanceUnit: SmallDistanceUnit.IN_1_32,
    largeDistanceUnit: LargeDistanceUnit.MI,
  },
};

export const medias = [
  {
    createdOn: '2021-10-07T09:14:35.593Z',
    id: 'f4fa8b8a-a152-401d-82f0-ec2ca4d55ad0',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.846Z',
    id: '6b8dcaee-ad98-45b1-8fd1-845aacbabcea',
    originalPath: '/assets/images/medias/image_2.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_2.jpg',
    transformedPath: '/assets/images/medias/image_2.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_2.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.807Z',
    id: 'ddb8eafb-409d-46f3-bfff-794ae91e9349',
    originalPath: '/assets/images/medias/image_3.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_3.jpg',
    transformedPath: '/assets/images/medias/image_3.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_3.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:36.819Z',
    id: '365ff9e9-20fb-4802-8bca-8599aa2c2448',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.626Z',
    id: 'bee752ef-2365-443f-b83f-441429b99537',
    originalPath: '/assets/images/medias/image_5.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_5.jpg',
    transformedPath: '/assets/images/medias/image_5.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_5.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.563Z',
    id: 'cf87314c-31f2-4249-b30e-109d4ef0095b',
    originalPath: '/assets/images/medias/image_6.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_6.jpg',
    transformedPath: '/assets/images/medias/image_6.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_6.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:36.723Z',
    id: 'dcd1db63-6dc5-442e-8c91-b367562213b9',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.656Z',
    id: '2ebcdade-4848-46f5-a91c-9a0ac66e7529',
    originalPath: '/assets/images/medias/video.mp4',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    type: 'VIDEO',
    concatenated: false,
    time: 9,
    untranscodedPath: '/assets/images/medias/video.mp4',
    path: '/assets/images/medias/video.mp4',
  },
  {
    createdOn: '2021-10-07T09:14:36.792Z',
    id: 'bed0cdcf-b9a1-4ee9-a0db-0240408fd6c9',
    originalPath: '/assets/images/medias/video.mp4',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_2.jpg',
    type: 'VIDEO',
    concatenated: false,
    time: 11,
    untranscodedPath: '/assets/images/medias/video.mp4',
    path: '/assets/images/medias/video.mp4',
  },
  {
    createdOn: '2021-10-07T09:14:35.859Z',
    id: 'd983e104-a0ed-4c7e-9667-fb5275f4ab13',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.737Z',
    id: 'b9286f68-a6d7-4772-8bd6-d79f808f23ac',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.622Z',
    id: 'f963bb9a-7b23-4ab6-b937-c6362b7f7502',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.569Z',
    id: '2d721dea-11da-4152-bb48-a45a410558d7',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:36.693Z',
    id: 'fbb8ddec-b96b-40dd-9510-770798f754e6',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.700Z',
    id: '64af54c1-6292-4176-ad15-cdc2614afef7',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.665Z',
    id: '6e6027b6-a0e7-4119-8fee-cffe3a08c41a',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:36.760Z',
    id: 'c9df181f-cb02-4c00-90c7-89e6c029f29d',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.552Z',
    id: '5b3472f1-e065-46c9-8894-4a8bc9498666',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.644Z',
    id: '234f2c04-8e13-454e-829e-4e681a123da5',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.651Z',
    id: '082692b5-5b97-4a6a-b7fe-8fb620fa83cb',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.651Z',
    id: '9db16bd4-7695-4b80-b29c-73f42324d2db',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.617Z',
    id: '8a51d097-de9e-4754-b110-4224932526b9',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:36.643Z',
    id: '0987672f-0600-46fa-baab-9bd55be8c55c',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.850Z',
    id: '821295f1-6b7d-4ad1-8015-f00611a9e917',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.837Z',
    id: 'c390454a-2b76-4af9-9b52-296d42b3d58e',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:35.697Z',
    id: 'e209e233-04d7-4f1c-bc00-2afa7e27f843',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:36.636Z',
    id: '7a204bd9-4ec1-440d-84d3-ee790ddd2983',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:14:36.775Z',
    id: 'f7e24c06-31b8-45fc-9a68-0b5c51dd002d',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
];

export const imageMedias = [
  {
    createdOn: '2021-10-07T09:17:24.422Z',
    filename: '00.jpeg',
    id: '17bfbd3c-97bd-452b-829e-68f48cf95466',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:17:25.128Z',
    filename: '001.jpeg',
    id: '71fd5c02-3786-4be1-ae69-f41a7250e9ac',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:17:26.009Z',
    filename: '000.jpeg',
    id: 'd4db1e18-6c90-4055-8d4c-8df401fc9d6f',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:17:26.045Z',
    filename: '0000.jpeg',
    id: 'f10c705a-9dbd-43df-bfae-61931d6a5a97',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:17:26.278Z',
    filename: '00000.jpeg',
    id: 'b81bbe39-e61b-43fe-85b9-6701bddb561f',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:17:26.143Z',
    filename: '00000000.jpeg',
    id: '35deb65d-c634-4672-bf35-93c354ccc150',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
];

export const videoAndImagesMedias = [
  {
    filename: 'document.pdf',
    id: 'ce890b35-d3e7-4d7b-b7bc-1e70937a9e3a',
    originalPath: '/assets/images/medias/document.pdf',
    restricted: false,
    type: 'DOCUMENT',
    path: '/assets/images/medias/document.pdf',
  },
  {
    createdOn: '2021-10-07T09:17:56.815Z',
    filename: '0000.jpeg',
    id: '65c50b80-6595-46e9-902a-b0b5e804d869',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    filename: 'document.pdf',
    id: '2818a0c9-7d6a-4e3b-bd1b-e8535a40e882',
    originalPath: '/assets/images/medias/document.pdf',
    restricted: false,
    type: 'DOCUMENT',
    path: '/assets/images/medias/document.pdf',
  },
  {
    createdOn: '2021-10-07T09:17:56.733Z',
    filename: '00000000.jpeg',
    id: '2d1444de-3dda-4759-aa76-73cf62ae5ace',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    filename: 'document.pdf',
    id: 'd46d620e-0200-4c5f-a116-1fc84b880778',
    originalPath: '/assets/images/medias/document.pdf',
    restricted: false,
    type: 'DOCUMENT',
    path: '/assets/images/medias/document.pdf',
  },
  {
    createdOn: '2021-10-07T09:17:57.566Z',
    filename: '001.jpeg',
    id: '27be1e5f-7c4e-4cba-87b5-4f102720b71c',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:17:57.670Z',
    filename: '1-6.jpeg',
    id: '6203889d-44f9-450e-9b64-2192b1800f96',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    filename: 'document.xls',
    id: 'bc4a3727-61a3-4edd-b122-87ff800e71cb',
    originalPath: '/assets/images/medias/document.pdf',
    restricted: false,
    type: 'DOCUMENT',
    path: '/assets/images/medias/document.pdf',
  },
  {
    createdOn: '2021-10-07T09:17:57.925Z',
    filename: '1-5.jpeg',
    id: '3a4a9577-004a-4ba4-ab6e-86e5ba5702fd',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    createdOn: '2021-10-07T09:17:56.734Z',
    filename: '000.jpeg',
    id: '9e3118d4-77ae-4526-a654-a4acab0bc999',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    createdOn: '2021-10-07T09:17:58.047Z',
    filename: '000000.mp4',
    id: '39586e02-a26f-42fa-b247-c9810a6049d9',
    originalPath: '/assets/images/medias/video.mp4',
    restricted: false,
    thumbnailPath: '/assets/images/medias/video.mp4',
    type: 'VIDEO',
    concatenated: false,
    time: 9,
    untranscodedPath: '/assets/images/medias/video.mp4',
    path: '/assets/images/medias/video.mp4',
  },
  {
    createdOn: '2021-10-07T09:17:58.001Z',
    filename: '1-4.jpeg',
    id: '9880a6e6-5a07-42b7-8bc4-e0277c374c99',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    filename: 'document.zip',
    id: '33df6ea1-9b33-4acd-bd40-40924f3743b5',
    originalPath: '/assets/images/medias/document.pdf',
    restricted: false,
    type: 'DOCUMENT',
    path: '/assets/images/medias/document.pdf',
  },
  {
    filename: 'document.pdf',

    id: '7401dd7c-f39f-4519-896b-afca7130e9eb',
    originalPath: '/assets/images/medias/document.pdf',
    restricted: false,
    type: 'DOCUMENT',
    path: '/assets/images/medias/document.pdf',
  },
  {
    createdOn: '2021-10-07T09:17:57.819Z',
    filename: '1-3.jpeg',
    id: '58cc39f9-12c4-46a1-9fa0-5c554279b8bf',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    createdOn: '2021-10-07T09:17:59.165Z',
    filename: '1-2.jpeg',
    id: '11848d78-14aa-4193-b4da-b358c8b0c5ad',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    filename: 'document.pdf',

    id: 'b02e9777-386a-4ec3-94f7-27fb4d471324',
    originalPath: '/assets/images/medias/document.pdf',
    restricted: false,
    type: 'DOCUMENT',
    path: '/assets/images/medias/document.pdf',
  },
  {
    createdOn: '2021-10-07T09:17:58.684Z',
    filename: '1-1.jpeg',
    id: 'e883fe61-64a6-46c9-a429-492d883b9551',
    originalPath: '/assets/images/medias/image_4.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_4.jpg',
    transformedPath: '/assets/images/medias/image_4.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_4.jpg',
  },
  {
    createdOn: '2021-10-07T09:17:57.939Z',
    filename: '00000.jpeg',
    id: 'dbe5395e-139d-4ad0-a8e5-657d5e50ad27',
    originalPath: '/assets/images/medias/image_1.jpg',
    restricted: false,
    thumbnailPath: '/assets/images/medias/image_1.jpg',
    transformedPath: '/assets/images/medias/image_1.jpg',
    type: 'IMAGE',
    path: '/assets/images/medias/image_1.jpg',
  },
  {
    filename: 'document.pdf',

    id: '8e32b316-6dd7-4dc7-8213-f811450d4178',
    originalPath: '/assets/images/medias/document.pdf',
    restricted: false,
    type: 'DOCUMENT',
    path: '/assets/images/medias/document.pdf',
  },
  {
    filename: 'document.pdf',

    id: 'b64ec15a-d9dd-4bf5-92f9-282a95865cb2',
    originalPath: '/assets/images/medias/document.pdf',
    restricted: false,
    type: 'DOCUMENT',
    path: '/assets/images/medias/document.pdf',
  },
];

const basicChecklist = [
  {
    items: [
      {
        advices: [
          {
            adviceId: '0b3cd14a-ec64-4e54-96e8-65b9b300bff9',
            adviceName: createLabel('PÄDS'),
            authorId: '3dcecf6f-9ffb-4fed-ab35-444a7561d587',
            category: 'BRAKE',
            coefficient: 1,
            createdOn: '2022-11-15T10:21:24.129Z',
            depositPercentage: 0,
            discount: 1554.7,
            highlighted: false,
            imported: false,
            mandatory: false,
            medias,
            price: 2221,
            senderId: '2dfe5f07-0be9-4d67-b75e-4abbf4c60f3c',
            sentOn: '2022-11-15T10:21:56.688Z',
            severity: 'NONE',
            status: 'PENDING',
            version: 0,
            accepted: false,
            refused: false,
            proposed: false,
            discountedPrice: 666.3,
            hasDiscount: true,
            pending: false,
          },
        ],
        categoryId: 'a01b8359-f669-4973-b553-4e1622b0d272',
        categoryName: createLabel('Others'),
        others: true,
        price: 666.3,
      },
    ],
    name: 'Default',
    offeredChecklist: false,
    type: 'DONE',
    price: 666.3,
    default: true,
    languages: ALL_LANGUAGES,
  },
  {
    items: [
      {
        advices: [
          {
            adviceId: '8bc3975b-4c68-461f-a981-99c4989dd28a',
            adviceName: createLabel('Tire NS'),
            authorId: '3dcecf6f-9ffb-4fed-ab35-444a7561d587',
            category: 'OTHER',
            coefficient: 1,
            comment: "19'' AMG black rims",
            createdOn: '2022-11-15T10:21:24.130Z',
            depositPercentage: 0,
            description: {
              en_us: 'AMG tyres',
            },
            discount: 0,
            highlighted: false,
            imported: false,
            mandatory: false,
            medias,
            price: 120,
            senderId: '2dfe5f07-0be9-4d67-b75e-4abbf4c60f3c',
            sentOn: '2022-11-15T10:21:56.690Z',
            severity: 'LOW',
            status: 'PENDING',
            version: 0,
            accepted: false,
            refused: false,
            proposed: true,
            discountedPrice: 120,
            hasDiscount: false,
            pending: true,
          },
          {
            adviceId: 'ada9171a-3cd1-402e-aa78-33815939ad90',
            adviceName: createLabel('Tire OS'),
            authorId: '3dcecf6f-9ffb-4fed-ab35-444a7561d587',
            category: 'OTHER',
            coefficient: 1,
            createdOn: '2022-11-15T10:21:24.130Z',
            depositPercentage: 0,
            discount: 0,
            highlighted: false,
            imported: false,
            mandatory: false,
            price: 20,
            senderId: '2dfe5f07-0be9-4d67-b75e-4abbf4c60f3c',
            sentOn: '2022-11-15T10:21:56.690Z',
            severity: 'NONE',
            status: 'PENDING',
            version: 0,
            accepted: false,
            refused: false,
            proposed: false,
            discountedPrice: 20,
            hasDiscount: false,
            pending: false,
          },
          {
            adviceId: '7f52cc92-0b37-44b7-bc66-c7737a3cdeee',
            adviceName: createLabel('Geometry'),
            authorId: '3dcecf6f-9ffb-4fed-ab35-444a7561d587',
            category: 'OTHER',
            coefficient: 1,
            createdOn: '2022-11-15T10:21:24.130Z',
            depositPercentage: 0,
            discount: 0,
            highlighted: false,
            imported: false,
            mandatory: false,
            price: 60,
            senderId: '2dfe5f07-0be9-4d67-b75e-4abbf4c60f3c',
            sentOn: '2022-11-15T10:21:56.690Z',
            severity: 'HIGH',
            status: 'PENDING',
            version: 0,
            accepted: false,
            refused: false,
            proposed: true,
            discountedPrice: 60,
            hasDiscount: false,
            pending: true,
          },
          {
            adviceId: '36a3ef86-1fe1-436b-9b07-be240b3d4271',
            adviceName: createLabel('Neew'),
            authorId: '3dcecf6f-9ffb-4fed-ab35-444a7561d587',
            category: 'AC',
            coefficient: 1,
            createdOn: '2022-11-15T10:21:24.130Z',
            depositPercentage: 0,
            discount: 0,
            highlighted: false,
            imported: false,
            mandatory: false,
            price: 222,
            senderId: '2dfe5f07-0be9-4d67-b75e-4abbf4c60f3c',
            sentOn: '2022-11-15T10:21:56.690Z',
            severity: 'LOW',
            status: 'PENDING',
            version: 0,
            accepted: false,
            refused: false,
            proposed: true,
            discountedPrice: 222,
            hasDiscount: false,
            pending: true,
          },
          {
            adviceId: '56a8dd72-7821-4de7-8b61-b9f6c33fdcbe',
            adviceName: createLabel('new2'),
            authorId: '3dcecf6f-9ffb-4fed-ab35-444a7561d587',
            category: 'BATTERY',
            coefficient: 1,
            createdOn: '2022-11-15T10:21:24.130Z',
            depositPercentage: 0,
            discount: 0,
            highlighted: false,
            imported: false,
            mandatory: false,
            price: 665,
            senderId: '2dfe5f07-0be9-4d67-b75e-4abbf4c60f3c',
            sentOn: '2022-11-15T10:21:56.690Z',
            severity: 'HIGH',
            status: 'PENDING',
            version: 0,
            accepted: false,
            refused: false,
            proposed: true,
            discountedPrice: 665,
            hasDiscount: false,
            pending: true,
          },
          {
            adviceId: '02b22219-e87b-42b0-a57a-50cce2f1ffb3',
            adviceName: createLabel('fg'),
            authorId: '3dcecf6f-9ffb-4fed-ab35-444a7561d587',
            coefficient: 1,
            createdOn: '2022-11-15T10:21:24.130Z',
            depositPercentage: 0,
            discount: 0,
            highlighted: false,
            imported: false,
            mandatory: false,
            price: 189.7436,
            senderId: '2dfe5f07-0be9-4d67-b75e-4abbf4c60f3c',
            sentOn: '2022-11-15T10:21:56.690Z',
            severity: 'LOW',
            status: 'PENDING',
            version: 0,
            accepted: false,
            refused: false,
            proposed: true,
            discountedPrice: 189.7436,
            hasDiscount: false,
            pending: true,
          },
        ],
        categoryId: '92a0a2fe-08f0-4f1b-a754-a814f1d35db6',
        categoryName: createLabel('Tires'),
        others: false,
        price: 1276.7436,
      },
      {
        advices: [
          {
            adviceId: '2ea7553b-d24d-4049-8417-ea4e365c9da6',
            adviceName: createLabel('Front pads'),
            authorId: '3dcecf6f-9ffb-4fed-ab35-444a7561d587',
            category: 'OTHER',
            coefficient: 1,
            createdOn: '2022-11-15T10:21:24.131Z',
            depositPercentage: 0,
            discount: 0,
            highlighted: false,
            imported: false,
            mandatory: false,
            price: 279.99,
            senderId: '2dfe5f07-0be9-4d67-b75e-4abbf4c60f3c',
            sentOn: '2022-11-15T10:21:56.690Z',
            severity: 'LOW',
            status: 'PENDING',
            version: 0,
            accepted: false,
            refused: false,
            proposed: true,
            discountedPrice: 279.99,
            hasDiscount: false,
            pending: true,
          },
        ],
        categoryId: 'e6cd7156-c2f9-4594-93e0-c56bbedca76b',
        categoryName: createLabel('Brakes'),
        others: false,
        price: 1690.47,
      },
    ],
    name: 'Mercedes DE',
    offeredChecklist: false,
    originChecklistId: 'a72bf188-c442-3e8e-a7ef-2a3987f8f49b',
    type: 'WORK',
    price: 4277.0136,
    default: true,
    languages: ALL_LANGUAGES
  },
];

/** @type {Pick<import("modules/entity/subEntities/intervention/types").Intervention, 'customerRating' | 'ratingConfiguration'>} */
export const ratings = {
  ratingConfiguration: {
    googleRatingAddress: '/googleUrl',
    url: '/rateUrl',
  },
};

/** @type {import("modules/entity/subEntities/intervention/types").Payer[]} */
export const payers = [
  {
    id: 'payer1',
    name: createLabel('Leaser'),
  },
  {
    id: 'payer2',
    name: createLabel('Warranty'),
  },
];

/** @type {import("modules/entity/subEntities/intervention/types").Intervention} */
export const defaultIntervention = {
  id: '1',
  message:
    'Ü,Ö,ÄAn anniversary as a statement: The 55th Year Edition.\nWe have been redefining performance for 55 years. That includes the performance of an off-road vehicle. This G 63 special model pays homage to an impressive history and brings it to life with an appearance stamped by a strong character. Unique signets and a bold red define the interior, while the clear manufacture opalite white bright and prominent foiling carry the power outwards. An unmistakable combination that makes this exclusive G-Class Edition a real statement.\n"V8 BITURBO" lettering\nTrue power lurks within. The elegantly integrated “V8 Biturbo” lettering on the vehicle flanks is a visible sign of the essence at the heart of every AMG.',
  referenceId: 'Snapshot test',
  maxMessageLength: 1600,
  valueAddedTax: 17,
  acceptedManually: false,
  createdOn: '2022-11-15T10:21:24.039255Z',
  checklists: basicChecklist,
  translations,
  dealer,
  ratingConfiguration: {
    googleRatingAddress: '/googleUrl',
    url: '/rateUrl',
  },
  config: {
    minPayment: 1,
    maxPayment: 999999.99,
    maxInputLength: 4800,
  },
  sentBy: {
    displayName: 'Florent Mauer',
    validEmail: true,
    scheduler: false,
    email: 'florent.mauer@fleetback.com',
    onCustomerBehalf: false,
    id: '2dfe5f07-0be9-4d67-b75e-4abbf4c60f3c',
    type: 'USER',
  },
  vehicleInfo: {
    mileage: '56565',
    model: 'JD3 ceed SW',
    registration: 'ZR4576',
    registrationDate: '2022-11-15',
    vin: 'WBA7M910207E90311',
    fuelType: 'ELECTRIC',
    inspectionDate: '2025-22-15',
  },
  brand: {
    s3LogoPath: '/brands/mercedes_amg/mobile/mercedes-amg.png',
    name: 'Mercedes AMG',
    id: '07f7b0cb-9ac6-3a4d-a217-627163ec50c6',
  },
  customerInfo: {
    customerNumber: '3200Ä',
    firstName: 'DÄN',
    lastName: 'DieselÜ',
    status: 'ACTIVE',
    civility: 'MR',
    language: 'en_us',
    email: 'family@ee.ee',
    phoneNumber: {
      local: '131333',
      prefix: '352',
      search: '352 +352 00352 131333 0131333 352131333 +352131333 00352131333',
    },
    displayName: 'DÄN DieselÜ',
  },
  messages: [
    {
      visibility: 'PUBLIC',
      conversationId: '5a3e21a6-b600-425f-b5c7-ffa7cf232572',
      status: 'SENT',
      interventionId: '8d3a5f61-6520-4301-a36f-2d9c2ebbfafb',
      unread: false,
      createdOn: '2022-11-15T10:21:24.099920Z',
      createdBy: {
        displayName: 'Florent Mauer',
        validEmail: true,
        scheduler: false,
        email: 'florent.mauer@fleetback.com',
        onCustomerBehalf: false,
        id: '2dfe5f07-0be9-4d67-b75e-4abbf4c60f3c',
        type: 'USER',
      },
      authorId: '2dfe5f07-0be9-4d67-b75e-4abbf4c60f3c',
      sentOn: '2022-11-15T10:21:57.413136Z',
      id: 'c6b37fa7-1267-44bf-a5f7-380c5da0843e',
      content:
        'Ü,Ö,ÄAn anniversary as a statement: The 55th Year Edition.\nWe have been redefining performance for 55 years. That includes the performance of an off-road vehicle. This G 63 special model pays homage to an impressive history and brings it to life with an appearance stamped by a strong character. Unique signets and a bold red define the interior, while the clear manufacture opalite white bright and prominent foiling carry the power outwards. An unmistakable combination that makes this exclusive G-Class Edition a real statement.\n"V8 BITURBO" lettering\nTrue power lurks within. The elegantly integrated “V8 Biturbo” lettering on the vehicle flanks is a visible sign of the essence at the heart of every AMG.',
      channel: 'INTERNAL',
      type: 'MESSAGE',
    },
  ],
  payers,
  contact: {
    address: '28 Avenue de la Voie Domitienne, 34500 Béziers',
    shortName: 'GGB Béziers',
    senderId: 'PEUGEOT',
    tel: '04 67 35 49 00',
    city: 'Belval',
    confidentialityPolicy: 'https://www.confidentialitypolicy.com',
    email: 'contact@fleetback.com',
    fax: '04 67 35 49 00',
    generalTermsConditionsLink: 'https://www.gtc.com',
    legalNotice: 'https://www.legalnotice.com',
    name: 'GGB Béziers full',
    socialNetworks: {
      FACEBOOK: 'https://www.facebook.com/MyDealership/',
      INSTAGRAM: 'https://www.instagram.com/MyDealership/',
      YOUTUBE: 'https://www.instagram.com/MyDealership/',
      LINKEDIN: 'https://www.instagram.com/MyDealership/',
      X: 'https://www.instagram.com/MyDealership/'
    },
    stockEmail: 'stockemail@fleetback.com',
    website: 'https://www.website.com',
  },
};

export const campaignData = {
  expirationDate: '2099-12-31T22:59:59.999Z',
  template: {
    banner: 'https://fleetback.com/wp-content/uploads/2022/09/Rectangle-164.jpg',
  },
};
